import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  Json: any;
};

export type AddPublicUserBrandInput = {
  /** Indicates whether the user can read data from the brand. */
  canReadData: Scalars['Boolean'];
  /** Indicates whether the user can view dashboards from the brand. */
  canViewDashboards: Scalars['Boolean'];
  /** Brand identifier to be managed by user. */
  id: Scalars['String'];
};

export type AdsCampaignSample = {
  __typename?: 'AdsCampaignSample';
  /** Sponsored Brands Campaigns */
  sbCampaigns: Array<Scalars['String']>;
  /** Sponsored Display Campaigns */
  sdCampaigns: Array<Scalars['String']>;
  /** Sponsored Products Campaigns */
  spCampaigns: Array<Scalars['String']>;
};

export type AdvertisingProfile = {
  __typename?: 'AdvertisingProfile';
  /** Country code of the advertising profile. */
  countryCode: Scalars['String'];
  /** Id of the advertising profile. */
  id: Scalars['String'];
  /** Name of the advertising account associated with the profile. */
  name: Scalars['String'];
  /** Type of the advertising account associated with the profile. */
  type: Scalars['String'];
};

export type AppData = {
  __typename?: 'AppData';
  /** Application code size in bytes */
  codeSize?: Maybe<Scalars['Int']>;
  /** Deployment identifier, if known */
  deploymentId?: Maybe<Scalars['String']>;
  /** Deployed application method, if known */
  deploymentMethod?: Maybe<Scalars['String']>;
  environmentType: Scalars['String'];
  /** Deployed application GIT commit identifier, if available */
  gitCommitId?: Maybe<Scalars['String']>;
  isLocalServer: Scalars['Boolean'];
  /** DateTime when the application's deployment was last updated */
  lastModifiedOn?: Maybe<Scalars['String']>;
  /** Number of application's reserved concurrent executions */
  numberReservedConcurrentExecutions?: Maybe<Scalars['Int']>;
  /** Application runtime */
  runtime?: Maybe<Scalars['String']>;
  /** Application running version */
  version?: Maybe<Scalars['String']>;
};

export type BackfillStatus = {
  __typename?: 'BackfillStatus';
  /** The API connection name. */
  connectionName: Scalars['String'];
  /** When the backfill has ended. */
  endedAt?: Maybe<Scalars['String']>;
  /** The backfill operation identifier. */
  id: Scalars['String'];
  /** When the backfill status last updated on. */
  lastUpdatedOn: Scalars['String'];
  /** Provides the percentage of completion [|0...100|] if available. */
  percentageCompletion?: Maybe<Scalars['Float']>;
  /** The public partner identifier. */
  publicPartnerId: Scalars['String'];
  /** The Reason partner name. */
  reasonPartnerName: Scalars['String'];
  /** The Reason partner unique identifier. */
  reasonPartnerUuid: Scalars['String'];
  /** Reports being backfilled */
  reports: Array<BackfillStatusReport>;
  /** Requester's type */
  requestedBy: BackfillStatusRequestedByType;
  /** Requester's email */
  requesterEmail: Scalars['String'];
  /** When the backfill was started. */
  startedAt?: Maybe<Scalars['String']>;
  /** Describes the current backfill status. */
  status: BackfillStatusType;
};

export type BackfillStatusReport = {
  __typename?: 'BackfillStatusReport';
  /** Description for the report. */
  description?: Maybe<Scalars['String']>;
  /** The backfill operation report identifier. */
  id: Scalars['String'];
  /** Type of schema. */
  outputSchemaType: PublicSchemaReportSchemaType;
  /** Name of the output table. */
  outputTableName: Scalars['String'];
  /** Describes the related public schema entry. */
  publicSchema?: Maybe<PublicSchemaReport>;
  /** Display name for the report. */
  reportName: Scalars['String'];
  /** All periods requested for backfill.. */
  requestedPeriods: Array<BackfillStatusReportPeriod>;
};

export type BackfillStatusReportPeriod = {
  __typename?: 'BackfillStatusReportPeriod';
  /** The requested ending backfill date. */
  backfillEndDate?: Maybe<Scalars['String']>;
  /** The requested starting backfill date. */
  backfillStartDate?: Maybe<Scalars['String']>;
  /** The backfill operation report period identifier. */
  id: Scalars['String'];
  /** The period being backfilled. */
  period: PublicSchemaReportCoveredPeriod;
};

export enum BackfillStatusRequestedByType {
  Reason = 'REASON',
  User = 'USER'
}

export enum BackfillStatusType {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Queued = 'QUEUED'
}

export type CancelBrandDashboardSeatPublicUserResult = {
  __typename?: 'CancelBrandDashboardSeatPublicUserResult';
  /** When the cancel will occur. */
  cancelOn?: Maybe<Scalars['String']>;
  /** Indicates whether the cancellation was posted */
  didCancel: Scalars['Boolean'];
  /** The seat identifier */
  id: Scalars['String'];
  /** The pre-cancellation renew amount to be charged. */
  renewAmount?: Maybe<Scalars['Float']>;
  /** The pre-cancellation renew currency to be charged. */
  renewAmountCurrency?: Maybe<StripeCurrencyType>;
  /** The pre-cancellation renew period type. */
  renewPeriodType?: Maybe<StripePeriodType>;
};

export type DataReportAwaitForUploadedFileIngestionResult = {
  __typename?: 'DataReportAwaitForUploadedFileIngestionResult';
  /** The value of the data type column. */
  dataTypeName: Scalars['String'];
  /** Indicates whether the upload was successfully ingested. */
  isSuccess: Scalars['Boolean'];
  /** The least recent record createdOn timestamp. */
  leastRecentRecordCreatedOn: Scalars['String'];
  /** Table logs for the ingestion. */
  logs: Array<PublicPartnerDataTableLogs>;
  /** The least recent record createdOn timestamp. */
  mostRecentRecordCreatedOn: Scalars['String'];
  /** The value of the table name/custom view column. */
  tableName: Scalars['String'];
};

export type DataReportBannerAlarmDefinition = {
  __typename?: 'DataReportBannerAlarmDefinition';
  /** The date time when the banner is to be active from. */
  activatedOn?: Maybe<Scalars['String']>;
  /** The date time when the banner is to be active to. */
  activatedUntil?: Maybe<Scalars['String']>;
  /** Indicates whether the alarm can be discarded on client side. */
  canBeDiscarded: Scalars['Boolean'];
  /** The expanded banner content as html. */
  detailsHtml?: Maybe<Scalars['String']>;
  /** The banner identifier. */
  id: Scalars['String'];
  /** The path node type to be attached to. */
  nodeTypePath: Array<DataReportNodeType>;
  /** The banner title content as html. */
  titleHtml?: Maybe<Scalars['String']>;
};

export type DataReportNode = {
  __typename?: 'DataReportNode';
  /** The definition of banner alarms to be displayed. */
  bannerAlarmDefinition?: Maybe<Array<DataReportBannerAlarmDefinition>>;
  /** The children nodes to be displayed. */
  childrenNodes?: Maybe<Array<DataReportNode>>;
  /** Indicates whether to show on the left-side navigation tree. */
  hiddenInNavigationTree?: Maybe<Scalars['Boolean']>;
  /** The node icon in the navigation tree. */
  icon: DataReportNodeIcon;
  /** The node name in the navigation tree. */
  node: Scalars['String'];
  /** The type of node. */
  nodeType: DataReportNodeType;
  /** The browser page title for the node. */
  pageTitle: Scalars['String'];
  /** The definition for the PowerBI report viewer. */
  powerBIReportDefinition?: Maybe<DataReportPowerBiReportDefinition>;
  /** Indicates whether to show partner selection dropdown. */
  showPartnerSelectionDropdown: Scalars['Boolean'];
  /** The definition for the files to be uploaded by the control. */
  uploadFileDefinitions?: Maybe<Array<DataReportUploadFileDefinition>>;
  /** The url path for the node. If null, the node is hidden. */
  urlPath?: Maybe<Scalars['String']>;
};

export type DataReportNodeIcon = {
  __typename?: 'DataReportNodeIcon';
  /** The font-awesome classes for the node icon in the navigation tree. */
  fontAwesomeClasses?: Maybe<Array<Scalars['String']>>;
  /** The url for the node icon in the navigation tree. */
  httpIcon?: Maybe<Scalars['String']>;
};

export enum DataReportNodeType {
  AccountBilling = 'ACCOUNT_BILLING',
  AccountRoot = 'ACCOUNT_ROOT',
  AccountUsersAndPermissions = 'ACCOUNT_USERS_AND_PERMISSIONS',
  ApiConnections = 'API_CONNECTIONS',
  BackfillStatus = 'BACKFILL_STATUS',
  BannerAlarm = 'BANNER_ALARM',
  Dashboard = 'DASHBOARD',
  DashboardPbi = 'DASHBOARD_PBI',
  DatabaseCredentials = 'DATABASE_CREDENTIALS',
  FileUpload = 'FILE_UPLOAD',
  HelpReferencesAndGuides = 'HELP_REFERENCES_AND_GUIDES',
  HelpReportProblem = 'HELP_REPORT_PROBLEM',
  HelpRoot = 'HELP_ROOT',
  ManageConnection = 'MANAGE_CONNECTION',
  ManageYourDataTables = 'MANAGE_YOUR_DATA_TABLES',
  PowerbiReport = 'POWERBI_REPORT',
  Root = 'ROOT',
  Trackers = 'TRACKERS'
}

export type DataReportPowerBiReportDefinition = {
  __typename?: 'DataReportPowerBIReportDefinition';
  /** The report group identifier. */
  groupId: Scalars['String'];
  /** The report identifier. */
  id: Scalars['String'];
  /** The report friendly name. */
  name: Scalars['String'];
};

export enum DataReportType {
  AmazonProductCatalog = 'AMAZON_PRODUCT_CATALOG',
  AmazonSearchTerms = 'AMAZON_SEARCH_TERMS',
  Cogs = 'COGS',
  ProductCatalog = 'PRODUCT_CATALOG'
}

export type DataReportUploadFileDefinition = {
  __typename?: 'DataReportUploadFileDefinition';
  /** The value of the data type column. */
  dataTypeName: Scalars['String'];
  /** The instructions for the report download. */
  downloadInstructions: Array<Scalars['String']>;
  /** The file fields. */
  fields: Array<DataReportUploadFileFieldDefinition>;
  /** Indicates whether data was uploaded, otherwise template data is to retrieved on download. */
  hasDataUploaded?: Maybe<Scalars['Boolean']>;
  /** The date time when last uploaded. */
  lastUpdatedOn?: Maybe<Scalars['String']>;
  /** The report output table name. */
  outputTableName: Scalars['String'];
  /** The type of report. */
  reportType: DataReportType;
  /** The value of the table name/custom view column. */
  tableName: Scalars['String'];
  /** The unique fields, whose values must be unique per file uploaded. */
  uniqueFields: Array<DataReportUploadFileUniqueFieldDefinition>;
};

export type DataReportUploadFileFieldDefinition = {
  __typename?: 'DataReportUploadFileFieldDefinition';
  /** The alternative field names, if any. */
  alternativeNames: Array<Scalars['String']>;
  /** The field name. */
  name: Scalars['String'];
  /** The regex validation to be used for validation purposes. */
  regex?: Maybe<Scalars['String']>;
  /** Optional error message to be shown to user on regex validation failure. */
  regexErrorMessage?: Maybe<Scalars['String']>;
};

export type DataReportUploadFileUniqueFieldDefinition = {
  __typename?: 'DataReportUploadFileUniqueFieldDefinition';
  /** The field names, composing a unique constraint. */
  fieldNames: Array<Scalars['String']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type EnumMarketplaceFilter = {
  equals?: InputMaybe<Marketplace>;
  in?: InputMaybe<Array<Marketplace>>;
  not?: InputMaybe<NestedEnumMarketplaceFilter>;
  notIn?: InputMaybe<Array<Marketplace>>;
};

export type EnumMarketplaceUrlProductTypeFilter = {
  equals?: InputMaybe<MarketplaceUrlProductType>;
  in?: InputMaybe<Array<MarketplaceUrlProductType>>;
  not?: InputMaybe<NestedEnumMarketplaceUrlProductTypeFilter>;
  notIn?: InputMaybe<Array<MarketplaceUrlProductType>>;
};

export type GenerateFileUrlResponse = {
  __typename?: 'GenerateFileUrlResponse';
  /** Signed URL to be used for uploading file (using HTTP PUT) or for downloading file (using HTTP GET). */
  signedS3URL?: Maybe<Scalars['String']>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type LwaClientIdsResponse = {
  __typename?: 'LwaClientIdsResponse';
  /** Client Id to use to connect to LWA Advertising. */
  advertisingClientId: Scalars['String'];
  /** Client Id to use to connect to LWA SellerCentral/VendorCentral. */
  sellerVendorClientId: Scalars['String'];
};

export enum Marketplace {
  Ae = 'AE',
  Au = 'AU',
  Be = 'BE',
  Br = 'BR',
  Ca = 'CA',
  De = 'DE',
  Eg = 'EG',
  Es = 'ES',
  Eu = 'EU',
  Fr = 'FR',
  Gb = 'GB',
  Ie = 'IE',
  In = 'IN',
  It = 'IT',
  Jp = 'JP',
  Mx = 'MX',
  Nl = 'NL',
  Pl = 'PL',
  Sa = 'SA',
  Se = 'SE',
  Sg = 'SG',
  Tr = 'TR',
  Uk = 'UK',
  Us = 'US',
  Za = 'ZA'
}

export type MarketplaceUrl = {
  __typename?: 'MarketplaceUrl';
  baseAdvertisingUrl?: Maybe<Scalars['String']>;
  baseUrl: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  marketplace: Marketplace;
  productType: MarketplaceUrlProductType;
  revision: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type MarketplaceUrlMarketplaceProductTypeCompoundUniqueInput = {
  marketplace: Marketplace;
  productType: MarketplaceUrlProductType;
};

export type MarketplaceUrlOrderByWithRelationInput = {
  baseAdvertisingApiUrl?: InputMaybe<SortOrderInput>;
  baseAdvertisingUrl?: InputMaybe<SortOrderInput>;
  baseUrl?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  marketplace?: InputMaybe<SortOrder>;
  productType?: InputMaybe<SortOrder>;
  revision?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum MarketplaceUrlProductType {
  Advertising = 'ADVERTISING',
  Sellercentral = 'SELLERCENTRAL',
  Vendorcentral = 'VENDORCENTRAL'
}

export type MarketplaceUrlWhereInput = {
  AND?: InputMaybe<Array<MarketplaceUrlWhereInput>>;
  NOT?: InputMaybe<Array<MarketplaceUrlWhereInput>>;
  OR?: InputMaybe<Array<MarketplaceUrlWhereInput>>;
  baseAdvertisingApiUrl?: InputMaybe<StringNullableFilter>;
  baseAdvertisingUrl?: InputMaybe<StringNullableFilter>;
  baseUrl?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  marketplace?: InputMaybe<EnumMarketplaceFilter>;
  productType?: InputMaybe<EnumMarketplaceUrlProductTypeFilter>;
  revision?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MarketplaceUrlWhereUniqueInput = {
  AND?: InputMaybe<Array<MarketplaceUrlWhereInput>>;
  NOT?: InputMaybe<Array<MarketplaceUrlWhereInput>>;
  OR?: InputMaybe<Array<MarketplaceUrlWhereInput>>;
  baseAdvertisingApiUrl?: InputMaybe<StringNullableFilter>;
  baseAdvertisingUrl?: InputMaybe<StringNullableFilter>;
  baseUrl?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']>;
  marketplace?: InputMaybe<EnumMarketplaceFilter>;
  marketplace_productType?: InputMaybe<MarketplaceUrlMarketplaceProductTypeCompoundUniqueInput>;
  productType?: InputMaybe<EnumMarketplaceUrlProductTypeFilter>;
  revision?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Adds the given payment method for the given connected public partner. */
  addPaymentMethodStripe: Scalars['Boolean'];
  /** Getserts a public user. */
  addPublicUser: Scalars['Boolean'];
  /** Assign a seat to the given public user, brand for the given dashboard. */
  assignBrandDashboardSeatPublicUser?: Maybe<Scalars['Boolean']>;
  /** Awaits for uploaded file ingestion. */
  awaitForUploadedFileIngestion: DataReportAwaitForUploadedFileIngestionResult;
  /** Cancels an unassigned seat for the given public user, brand for the given dashboard. */
  cancelBrandDashboardSeatPublicUser: CancelBrandDashboardSeatPublicUserResult;
  /** Cancels the current plan for the given connected public partner. */
  cancelPlanStripe: Scalars['Boolean'];
  /** Connect a public partner to LWA. */
  connectAdvertisingPublicPartner: Scalars['Boolean'];
  /** Connect a public partner to LWA. */
  connectPublicPartner: Scalars['Boolean'];
  /** Create a new partner associated with the calling user. */
  createPublicPartner: PublicPartner;
  /** Delete a non-connected public partner. */
  deletePublicPartner: Scalars['Boolean'];
  /** Execute arbitrary Public Partner Query. */
  executePublicPartnerQuery?: Maybe<PublicPartnerQueryS3Result>;
  /** Export a PowerBI report. */
  exportPowerBIReport?: Maybe<PowerBiReportExport>;
  /** Gets a signed URL for downloading a given report file for a given partner and report type, or NULL when the template needs to be downloaded. */
  generateDownloadFileUrlData: GenerateFileUrlResponse;
  /** Gets a signed URL for downloading a given report template file for a given partner and report type. */
  generateDownloadTemplateFileUrlData: GenerateFileUrlResponse;
  /** Generate a PowerBI report embedUri and access token. */
  generatePowerBIReportContext?: Maybe<PowerBiReportContext>;
  /** Generate/refresh all system reports for a given public partner. */
  generateSystemReports: Scalars['Boolean'];
  /** Gets a signed URL for uploading a given report file for a given partner and report type. */
  generateUploadFileUrlData: GenerateFileUrlResponse;
  /** Get the help url for a given public schema. */
  getHelpUrlPublicSchema: PublicSchemaGetHelp;
  /** Get Rows of a Public Partner table. */
  getPublicPartnerTableRows?: Maybe<PublicPartnerQueryS3Result>;
  /** List Public Partner Tables. */
  listPublicPartnerTables?: Maybe<PublicPartnerTables>;
  /** Execute arbitrary Public Partner Query. */
  purchaseBackfills?: Maybe<Scalars['Boolean']>;
  /** Purchase a seat to the given public user, brand for the given dashboard. */
  purchaseBrandDashboardSeatPublicUser: PurchaseBrandDashboardSeatPublicUserResult;
  /** Purchase a given item based on saved payment method for the given connected public partner. */
  purchaseStripe: StripePurchase;
  /** Return enough information about a potential public partner so the user can decide whether to connect. */
  recognizePublicPartner: RecognizePublicPartnerResult;
  /** Refresh the status of a PowerBI report export. */
  refreshPowerBIReportExportStatus?: Maybe<PowerBiReportExportStatus>;
  /** Re-invites a public user. */
  reinvitePublicUser: Scalars['Boolean'];
  /** Removes all payment methods for the given connected public partner. */
  removeAllPaymentMethodsStripe: Scalars['Boolean'];
  /** Removes the given payment method from the given connected public partner. */
  removePaymentMethodStripe: Scalars['Boolean'];
  /** Removes a public user from their current scope */
  removePublicUser: Scalars['Boolean'];
  /** Select an advertising profile for a partner. */
  selectAdvertisingProfile: Scalars['Boolean'];
  /** Saves the billing information for the given connected public partner. */
  setBillingInformationStripe: Scalars['Boolean'];
  /** Set permissions on a given brand for a public user. */
  setBrandPermissionsPublicUser: Scalars['Boolean'];
  /** Saves the given payment method for the given connected public partner. */
  setPaymentMethodAsDefaultStripe: Scalars['Boolean'];
  /** Returns a Stripe setupIntent for the given connected public partner. */
  setupIntentStripe?: Maybe<StripeSetupIntent>;
  /** Unassign a seat to the given public user, brand for the given dashboard. */
  unassignBrandDashboardSeatPublicUser?: Maybe<Scalars['Boolean']>;
  /** Update Google Sheets plan for a given public partner. */
  updateGoogleSheetsPlanPublicPartner: UpdateGoogleSheetsPlanPublicPartnerResult;
  /** Update a new partner associated with the calling user. */
  updatePublicPartner?: Maybe<PublicPartner>;
  /** Updates checklist item completion status. */
  updatePublicPortalChecklistItem?: Maybe<PublicPortalChecklist>;
};


export type MutationAddPaymentMethodStripeArgs = {
  partnerId: Scalars['String'];
  paymentMethodId: Scalars['String'];
};


export type MutationAddPublicUserArgs = {
  brandIds?: InputMaybe<Array<Scalars['String']>>;
  brands?: InputMaybe<Array<AddPublicUserBrandInput>>;
  email: Scalars['String'];
  name: Scalars['String'];
};


export type MutationAssignBrandDashboardSeatPublicUserArgs = {
  brandId: Scalars['String'];
  dashboardName: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationAwaitForUploadedFileIngestionArgs = {
  partnerId: Scalars['String'];
  reportType: DataReportType;
  silentOnSuccess?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCancelBrandDashboardSeatPublicUserArgs = {
  brandId: Scalars['String'];
  dashboardName: Scalars['String'];
  evalOnly: Scalars['Boolean'];
  id: Scalars['String'];
};


export type MutationCancelPlanStripeArgs = {
  partnerId: Scalars['String'];
};


export type MutationConnectAdvertisingPublicPartnerArgs = {
  code: Scalars['String'];
  partnerId: Scalars['String'];
  redirectUri: Scalars['String'];
};


export type MutationConnectPublicPartnerArgs = {
  code: Scalars['String'];
  partnerId: Scalars['String'];
  redirectUri: Scalars['String'];
  refreshToken?: InputMaybe<Scalars['String']>;
  sellingPartnerId: Scalars['String'];
};


export type MutationCreatePublicPartnerArgs = {
  partner: PublicPartnerInput;
};


export type MutationDeletePublicPartnerArgs = {
  partnerId: Scalars['String'];
};


export type MutationExecutePublicPartnerQueryArgs = {
  partnerId: Scalars['String'];
  query: Scalars['String'];
};


export type MutationExportPowerBiReportArgs = {
  bookmarkState?: InputMaybe<Scalars['String']>;
  format: PowerBiReportExportFormat;
  groupId: Scalars['String'];
  pages?: InputMaybe<Array<PowerBiReportExportPageInput>>;
  reportId: Scalars['String'];
};


export type MutationGenerateDownloadFileUrlDataArgs = {
  partnerId: Scalars['String'];
  reportType: DataReportType;
};


export type MutationGenerateDownloadTemplateFileUrlDataArgs = {
  partnerId: Scalars['String'];
  reportType: DataReportType;
};


export type MutationGeneratePowerBiReportContextArgs = {
  groupId: Scalars['String'];
  reportId: Scalars['String'];
};


export type MutationGenerateSystemReportsArgs = {
  publicPartnerId: Scalars['String'];
};


export type MutationGenerateUploadFileUrlDataArgs = {
  partnerId: Scalars['String'];
  reportType: DataReportType;
};


export type MutationGetHelpUrlPublicSchemaArgs = {
  schemaType: PublicSchemaReportSchemaType;
  tableName: Scalars['String'];
};


export type MutationGetPublicPartnerTableRowsArgs = {
  columns?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  partnerId: Scalars['String'];
  tableName: Scalars['String'];
};


export type MutationListPublicPartnerTablesArgs = {
  partnerId: Scalars['String'];
};


export type MutationPurchaseBackfillsArgs = {
  backfillsToBePurchased: Array<PublicPartnerDataTableBackfillInput>;
  publicPartnerId: Scalars['String'];
};


export type MutationPurchaseBrandDashboardSeatPublicUserArgs = {
  brandId: Scalars['String'];
  dashboardName: Scalars['String'];
  evalOnly: Scalars['Boolean'];
};


export type MutationPurchaseStripeArgs = {
  partnerId: Scalars['String'];
  paymentMethodId?: InputMaybe<Scalars['String']>;
  purchaseType: StripePurchaseType;
};


export type MutationRecognizePublicPartnerArgs = {
  accountType: PublicPartnerType;
  adsProfileId?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
  marketPlace?: InputMaybe<Scalars['String']>;
  redirectUri: Scalars['String'];
  sellingPartnerId?: InputMaybe<Scalars['String']>;
};


export type MutationRefreshPowerBiReportExportStatusArgs = {
  exportId: Scalars['String'];
  format: PowerBiReportExportFormat;
  groupId: Scalars['String'];
  reportId: Scalars['String'];
};


export type MutationReinvitePublicUserArgs = {
  id: Scalars['String'];
};


export type MutationRemoveAllPaymentMethodsStripeArgs = {
  partnerId: Scalars['String'];
};


export type MutationRemovePaymentMethodStripeArgs = {
  partnerId: Scalars['String'];
  paymentMethodId: Scalars['String'];
};


export type MutationRemovePublicUserArgs = {
  id: Scalars['String'];
};


export type MutationSelectAdvertisingProfileArgs = {
  advertisingProfileId: Scalars['String'];
  partnerId: Scalars['String'];
};


export type MutationSetBillingInformationStripeArgs = {
  billingInformation: StripeBillingInformationInput;
  partnerId: Scalars['String'];
};


export type MutationSetBrandPermissionsPublicUserArgs = {
  brandId: Scalars['String'];
  canBuy?: InputMaybe<Scalars['Boolean']>;
  canManageConnections?: InputMaybe<Scalars['Boolean']>;
  canReadData?: InputMaybe<Scalars['Boolean']>;
  canViewDashboards?: InputMaybe<Scalars['Boolean']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  isBillingAdmin?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['String'];
};


export type MutationSetPaymentMethodAsDefaultStripeArgs = {
  partnerId: Scalars['String'];
  paymentMethodId?: InputMaybe<Scalars['String']>;
};


export type MutationSetupIntentStripeArgs = {
  partnerId: Scalars['String'];
};


export type MutationUnassignBrandDashboardSeatPublicUserArgs = {
  brandId: Scalars['String'];
  dashboardName: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationUpdateGoogleSheetsPlanPublicPartnerArgs = {
  evalOnly: Scalars['Boolean'];
  partnerId: Scalars['String'];
  planName: Scalars['String'];
};


export type MutationUpdatePublicPartnerArgs = {
  friendlyName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  partnerId: Scalars['String'];
};


export type MutationUpdatePublicPortalChecklistItemArgs = {
  checklistItemId: Scalars['String'];
  completed: Scalars['Boolean'];
  partnerId?: InputMaybe<Scalars['String']>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type NestedEnumMarketplaceFilter = {
  equals?: InputMaybe<Marketplace>;
  in?: InputMaybe<Array<Marketplace>>;
  not?: InputMaybe<NestedEnumMarketplaceFilter>;
  notIn?: InputMaybe<Array<Marketplace>>;
};

export type NestedEnumMarketplaceUrlProductTypeFilter = {
  equals?: InputMaybe<MarketplaceUrlProductType>;
  in?: InputMaybe<Array<MarketplaceUrlProductType>>;
  not?: InputMaybe<NestedEnumMarketplaceUrlProductTypeFilter>;
  notIn?: InputMaybe<Array<MarketplaceUrlProductType>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export enum NullsOrder {
  First = 'first',
  Last = 'last'
}

export type PowerBiReportContext = {
  __typename?: 'PowerBIReportContext';
  /** PowerBI report access token */
  accessToken: Scalars['String'];
  /** PowerBI report embedUrl */
  embedUrl: Scalars['String'];
};

export type PowerBiReportExport = {
  __typename?: 'PowerBIReportExport';
  /** PowerBI report export identifier */
  exportId: Scalars['String'];
};

export enum PowerBiReportExportFormat {
  Pdf = 'PDF',
  Pptx = 'PPTX'
}

export type PowerBiReportExportPageInput = {
  /** PowerBI bookmark to apply on the page */
  bookmark?: InputMaybe<Scalars['String']>;
  /** PowerBI page name */
  pageName: Scalars['String'];
  /** PowerBI name of the visual to export. Specify a name, in case only a single visual from this page is exported. */
  visualName?: InputMaybe<Scalars['String']>;
};

export type PowerBiReportExportStatus = {
  __typename?: 'PowerBIReportExportStatus';
  /** PowerBI report download URL */
  downloadUrl?: Maybe<Scalars['String']>;
  /** Export completion percentage (0...100) */
  exportCompletionPercentage: Scalars['Int'];
  /** PowerBI report name */
  reportName: Scalars['String'];
  /** Export status */
  status: PowerBiReportExportStatusType;
};

export enum PowerBiReportExportStatusType {
  Completed = 'Completed',
  InProgress = 'InProgress'
}

export type PowerBiReportPage = {
  __typename?: 'PowerBIReportPage';
  /** The display name of the report page */
  displayName: Scalars['String'];
  /** PowerBI report group identifier */
  groupId: Scalars['String'];
  /** The order of the report page */
  order: Scalars['Int'];
  /** The internal name of the report page */
  pageName: Scalars['String'];
  /** PowerBI report report identifier */
  reportId: Scalars['String'];
  /** PowerBI report name */
  reportName: Scalars['String'];
};

export type PublicPartner = {
  __typename?: 'PublicPartner';
  /** If the partner is type Advertising, their associated account information id. */
  advertisingAccountId?: Maybe<Scalars['String']>;
  /** If the partner is type Advertising, their associated account information marketplace id. */
  advertisingAccountMarketplaceId?: Maybe<Scalars['String']>;
  /** If the partner is type Advertising, their associated account information name */
  advertisingAccountName?: Maybe<Scalars['String']>;
  advertisingProfileId?: Maybe<Scalars['String']>;
  /** Indicates whether the entry can be deleted. */
  canBeDeleted: Scalars['Boolean'];
  /** Describes the connection status to Reason through LWA. */
  connectedStatus: PublicPartnerConnectionStatus;
  createdAt: Scalars['DateTime'];
  /** The dashboards for the brand and user. Requires Admin access level. */
  dashboards?: Maybe<Array<PublicUserBrandDashboard>>;
  /** Indicates whether the client has connected the account to Seller, Vendor or Advertising credentials. */
  encryptedPayload?: Maybe<Scalars['Json']>;
  /** User-defined friendly display name. */
  friendlyName?: Maybe<Scalars['String']>;
  /** The Google Sheets plan for this brand. Requires Admin access level. */
  googleSheetsPlan?: Maybe<PublicPartnerGoogleSheetsPlan>;
  /** Indicates whether the client has connected the account to Seller, Vendor or Advertising credentials. */
  hasClientConnectedCredentials: Scalars['Boolean'];
  id: Scalars['String'];
  /** Whether the partner is connected to Reason through LWA. */
  isConnected: Scalars['Boolean'];
  marketplace: Marketplace;
  name: Scalars['String'];
  reasonPartnerName?: Maybe<Scalars['String']>;
  reasonPartnerUuid?: Maybe<Scalars['String']>;
  revision: Scalars['Int'];
  type: PublicPartnerType;
  updatedAt: Scalars['DateTime'];
  /** Lists all users for this brand. Requires Admin access level. */
  users?: Maybe<Array<PublicPartnerUser>>;
};

export enum PublicPartnerAuthenticationErrorCode {
  MissingAdsProfileId = 'MISSING_ADS_PROFILE_ID',
  MissingAuthPayload = 'MISSING_AUTH_PAYLOAD'
}

export enum PublicPartnerConnectionStatus {
  AuthorizationExpired = 'AUTHORIZATION_EXPIRED',
  AuthorizationProgress = 'AUTHORIZATION_PROGRESS',
  BeginAuthorization = 'BEGIN_AUTHORIZATION',
  Connected = 'CONNECTED',
  NeedsReauthorization = 'NEEDS_REAUTHORIZATION'
}

export type PublicPartnerCredentials = {
  __typename?: 'PublicPartnerCredentials';
  /** Describes the connection information for BigQuery. */
  bigquery?: Maybe<PublicPartnerCredentialsBigQuery>;
  /** Describes the connection information for Postgres. */
  postgresql?: Maybe<PublicPartnerCredentialsPostgreSql>;
  /** Unique connection slug. */
  slug: Scalars['String'];
  /** Describes the connection information for Snowflake. */
  snowflake?: Maybe<PublicPartnerCredentialsSnowflake>;
  /** Describes the connection type. */
  type: PublicPartnerCredentialsType;
};

export type PublicPartnerCredentialsBigQuery = {
  __typename?: 'PublicPartnerCredentialsBigQuery';
  /** The message to be displayed. */
  message: Scalars['String'];
};

export type PublicPartnerCredentialsPostgreSql = {
  __typename?: 'PublicPartnerCredentialsPostgreSQL';
  /** The PostgreSQL connection database name. */
  database: Scalars['String'];
  /** The PostgreSQL connection host name. */
  host: Scalars['String'];
  /** The PostgreSQL connection password. */
  password: Scalars['String'];
  /** The PostgreSQL connection host port. */
  port: Scalars['Int'];
  /** Indicates whether to leverage SSL for connectivity. */
  ssl?: Maybe<Scalars['Boolean']>;
  /** The PostgreSQL connection username. */
  userName: Scalars['String'];
};

export type PublicPartnerCredentialsSnowflake = {
  __typename?: 'PublicPartnerCredentialsSnowflake';
  /** The message to be displayed. */
  message: Scalars['String'];
};

export enum PublicPartnerCredentialsType {
  Bigquery = 'BIGQUERY',
  Postgresql = 'POSTGRESQL',
  Snowflake = 'SNOWFLAKE'
}

export type PublicPartnerDataTable = {
  __typename?: 'PublicPartnerDataTable';
  /** The report's backfill capabilities. */
  backfillsAvailable: Array<PublicPartnerDataTableBackfill>;
  /** The data status. */
  dataStatus?: Maybe<PublicPartnerDataTableReportDataStatus>;
  /** The record unique identifier. */
  id: Scalars['String'];
  /** Type of schema. */
  outputSchemaType: PublicSchemaReportSchemaType;
  /** Name of the output table. */
  outputTableName: Scalars['String'];
  /** Related public schema, if available. */
  publicSchema?: Maybe<PublicSchemaReport>;
  /** The report status. */
  reportStatus: PublicPartnerDataTableReportStatus;
  /** The report table logs. */
  tableLogs?: Maybe<Array<PublicPartnerDataTableLogs>>;
};

export type PublicPartnerDataTableBackfill = {
  __typename?: 'PublicPartnerDataTableBackfill';
  /** Describes the related schema report periods. */
  backfillPeriods: Array<PublicSchemaReportPeriod>;
  /** The backfill amount price. */
  priceAmount?: Maybe<Scalars['Float']>;
  /** The backfill price currency. */
  priceCurrency?: Maybe<StripeCurrencyType>;
};

export type PublicPartnerDataTableBackfillInput = {
  /** Describes the related schema report periods. */
  backfillPeriods: Array<PublicSchemaReportPeriodInput>;
  /** The backfill amount price. */
  priceAmount?: InputMaybe<Scalars['Float']>;
  /** The backfill price currency. */
  priceCurrency?: InputMaybe<StripeCurrencyType>;
};

export type PublicPartnerDataTableLogs = {
  __typename?: 'PublicPartnerDataTableLogs';
  /** The BigQuery database target */
  bigQueryTarget?: Maybe<PublicPartnerDataTableLogsBigQueryTarget>;
  /** The data status. */
  dataStatus: PublicPartnerDataTableReportWriteSinkStatus;
  /** The record unique identifier. */
  id: Scalars['String'];
  /** The last error encountered. */
  lastError?: Maybe<Scalars['String']>;
  /** When failed last on. */
  lastFailedOn?: Maybe<Scalars['String']>;
  /** When was last ingested on. */
  lastIngestedOn?: Maybe<Scalars['String']>;
  /** When succeeded last on. */
  lastSucceededOn?: Maybe<Scalars['String']>;
  /** Number of rows inserted, if available. */
  numberRowsCreated?: Maybe<Scalars['Int']>;
  /** Number of rows updated, if available. */
  numberRowsUpdated?: Maybe<Scalars['Int']>;
  /** The PostgreSQL database target */
  postgreSQLTarget?: Maybe<PublicPartnerDataTableLogsPostgreSqlTarget>;
  /** The Snowflake database target */
  snowflakeTarget?: Maybe<PublicPartnerDataTableLogsSnowflakeTarget>;
  /** Slug of the output sink. */
  writeSinkSlug: Scalars['String'];
};

export type PublicPartnerDataTableLogsBigQueryTarget = {
  __typename?: 'PublicPartnerDataTableLogsBigQueryTarget';
  /** The database name. */
  databaseName: Scalars['String'];
  /** The dataset id for the partner BigQuery project. */
  datasetId: Scalars['String'];
  /** Slug of the target. */
  id: Scalars['String'];
  /** The BigQuery Project Id. */
  projectId: Scalars['String'];
};

export type PublicPartnerDataTableLogsPostgreSqlTarget = {
  __typename?: 'PublicPartnerDataTableLogsPostgreSQLTarget';
  /** The PostgreSQL connection database name. */
  databaseName: Scalars['String'];
  /** The PostgreSQL connection host name. */
  hostName: Scalars['String'];
  /** Slug of the target. */
  id: Scalars['String'];
  /** The PostgreSQL connection host port. */
  port: Scalars['Int'];
  /** Indicates whether to leverage SSL for connectivity. */
  ssl?: Maybe<Scalars['Boolean']>;
  /** The PostgreSQL connection username. */
  userName: Scalars['String'];
};

export type PublicPartnerDataTableLogsSnowflakeTarget = {
  __typename?: 'PublicPartnerDataTableLogsSnowflakeTarget';
  /** The database name. */
  databaseName: Scalars['String'];
  /** Slug of the target. */
  id: Scalars['String'];
};

export enum PublicPartnerDataTableReportDataStatus {
  Synchronizing = 'SYNCHRONIZING',
  UpToDate = 'UP_TO_DATE',
  Warning = 'WARNING'
}

export enum PublicPartnerDataTableReportStatus {
  Disabled = 'DISABLED',
  DisabledCanBeEnabled = 'DISABLED_CAN_BE_ENABLED',
  DisabledNeedConnection = 'DISABLED_NEED_CONNECTION',
  Enabled = 'ENABLED',
  NeedConnectionCredentials = 'NEED_CONNECTION_CREDENTIALS'
}

export enum PublicPartnerDataTableReportWriteSinkStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Ingesting = 'INGESTING',
  Queued = 'QUEUED',
  Writing = 'WRITING'
}

export type PublicPartnerGoogleSheetsPlan = {
  __typename?: 'PublicPartnerGoogleSheetsPlan';
  /** The plan currency. */
  currency: Scalars['String'];
  /** The plan period type. */
  periodType: Scalars['String'];
  /** The plan price. */
  price: Scalars['Int'];
  /** Plan tier. */
  tier: Scalars['String'];
};

export type PublicPartnerInput = {
  /** Marketplace the product is in. */
  marketplace: Marketplace;
  /** Partner name. */
  name: Scalars['String'];
  /** Partner product type. */
  type: PublicPartnerType;
};

export type PublicPartnerQueryS3Result = {
  __typename?: 'PublicPartnerQueryS3Result';
  /** Number of cells in the results. */
  cellCount: Scalars['Int'];
  /** URL to the query results. */
  resultUrl: Scalars['String'];
  /** Size of the results in bytes. */
  size: Scalars['Int'];
};

export type PublicPartnerTable = {
  __typename?: 'PublicPartnerTable';
  /** The list of columns. */
  columns: Array<PublicPartnerTableColumn>;
  /** The help URL for the table. */
  helpUrl?: Maybe<Scalars['String']>;
  /** The table name. */
  name: Scalars['String'];
};

export type PublicPartnerTableColumn = {
  __typename?: 'PublicPartnerTableColumn';
  /** The data type of the column. */
  dataType: Scalars['String'];
  /** The column name. */
  name: Scalars['String'];
};

export type PublicPartnerTableRows = {
  __typename?: 'PublicPartnerTableRows';
  /** The list of columns. */
  columns: Array<Scalars['String']>;
  /** The list of rows. */
  rows: Array<Array<Maybe<Scalars['String']>>>;
};

export type PublicPartnerTables = {
  __typename?: 'PublicPartnerTables';
  /** The list of tables. */
  tables: Array<PublicPartnerTable>;
};

export enum PublicPartnerType {
  Advertising = 'ADVERTISING',
  Avn = 'AVN',
  Sellercentral = 'SELLERCENTRAL',
  Vendorcentral = 'VENDORCENTRAL'
}

export type PublicPartnerUser = {
  __typename?: 'PublicPartnerUser';
  /** Indicates whether the user can enable/disable reports and buy backfills. */
  canBuyData: Scalars['Boolean'];
  /** Indicates whether the user can manage API connections. */
  canManageConnections: Scalars['Boolean'];
  /** Indicates whether the user can read data. */
  canReadData: Scalars['Boolean'];
  /** Indicates whether the user can view reports. */
  canViewDashboards: Scalars['Boolean'];
  /** The user email. */
  email: Scalars['String'];
  /** The user identifier. */
  id: Scalars['String'];
  /** Indicates whether the user is having account administrative privileges. */
  isAdmin: Scalars['Boolean'];
  /** Indicates whether the user is having billing administrative privileges. */
  isBillingAdmin: Scalars['Boolean'];
  /** The user status. */
  status: PublicUserStatus;
};

export type PublicPortalChecklist = {
  __typename?: 'PublicPortalChecklist';
  /** The checklist description. */
  description: Scalars['String'];
  /** The checklist id. */
  id: Scalars['String'];
  /** The checklist items. */
  items: Array<PublicPortalChecklistItem>;
  /** The checklist name. */
  name: Scalars['String'];
};

export type PublicPortalChecklistItem = {
  __typename?: 'PublicPortalChecklistItem';
  /** The checklist item completion status. */
  completed: Scalars['Boolean'];
  /** The checklist item id. */
  id: Scalars['String'];
  /** The checklist item order. */
  order: Scalars['Int'];
  /** The checklist item value. */
  value: Scalars['String'];
};

export type PublicSchemaGetHelp = {
  __typename?: 'PublicSchemaGetHelp';
  /** The url for the help. */
  url: Scalars['String'];
};

export type PublicSchemaReport = {
  __typename?: 'PublicSchemaReport';
  /** Indicates whether backfill is allowed. */
  allowsBackfill: Scalars['Boolean'];
  /** Date/Time the object was created. */
  createdOn: Scalars['String'];
  /** The custom views for this schema report. */
  customViews?: Maybe<Array<PublicSchemaReportCustomView>>;
  /** The derivative scripts associated with this schema report. */
  derivativeScripts?: Maybe<Array<PublicSchemaReportDerivativeScript>>;
  /** The report description. */
  description: Scalars['String'];
  /** The fields for this schema report. */
  fields?: Maybe<Array<PublicSchemaReportWithMarketplaceField>>;
  /** The unique identifier. */
  id: Scalars['String'];
  /** The indices for this schema report. */
  indices?: Maybe<Array<PublicSchemaReportIndex>>;
  /** Indicates whether the report is reason system report. e.g. _partner_metadata etc. */
  isRASystemReport: Scalars['Boolean'];
  /** The email of the user performing the latest update. */
  lastUpdatedBy?: Maybe<Scalars['String']>;
  /** The report name. */
  name: Scalars['String'];
  /** The report output schema name. */
  outputSchemaName: PublicSchemaReportSchemaType;
  /** The report output table name. */
  outputTableName: Scalars['String'];
  /** The supported report periods. */
  periods: Array<PublicSchemaReportPeriod>;
  /** The report portal type. */
  portalType: PublicSchemaReportPortalType;
  /** The help page on help.reasonautomation.com, if known. */
  reasonAutomationHelpUrl?: Maybe<Scalars['String']>;
  /** The report's processing type. */
  reportProcessingType: PublicSchemaReportProcessingType;
  /** The revision number. */
  revision: Scalars['Int'];
  /** The additional sources for this schema report. */
  sources?: Maybe<Array<PublicSchemaReportSource>>;
  /** Indicates whether to truncate the existing data on update. */
  truncateOnUpdate: Scalars['Boolean'];
  /** The report's update frequency. */
  updateFrequency: PublicSchemaReportUpdateFrequency;
  /** When the object was last updated. */
  updatedAt: Scalars['String'];
};


export type PublicSchemaReportFieldsArgs = {
  allRevisions?: InputMaybe<Scalars['Boolean']>;
};


export type PublicSchemaReportIndicesArgs = {
  onlyUnique?: InputMaybe<Scalars['Boolean']>;
};

export enum PublicSchemaReportCoveredPeriod {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Snapshot = 'SNAPSHOT',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type PublicSchemaReportCustomView = {
  __typename?: 'PublicSchemaReportCustomView';
  /** The description for the custom view. */
  description: Scalars['String'];
  /** The source code for the custom view */
  implementationCode?: Maybe<Scalars['String']>;
  /** The language type for this custom view. */
  languageTypes: Array<PublicSchemaReportCustomViewLanguageType>;
  /** The name of the custom view. */
  name: Scalars['String'];
  /** The schema type of the custom view. */
  schemaType: PublicSchemaReportSchemaType;
};

export enum PublicSchemaReportCustomViewLanguageType {
  BigquerySql = 'BIGQUERY_SQL',
  Postgresql = 'POSTGRESQL',
  SnowflakeSql = 'SNOWFLAKE_SQL'
}

export type PublicSchemaReportDerivativeScript = {
  __typename?: 'PublicSchemaReportDerivativeScript';
  /** The schema to run the script against. */
  derivativeType: PublicSchemaReportDerivativeType;
  /** The description for the derivative script. */
  description: Scalars['String'];
  /** The language type for this derivative script. */
  languageTypes: Array<PublicSchemaReportCustomViewLanguageType>;
  /** The name of the derivative script. */
  name: Scalars['String'];
  /** The source code for the derivative script. */
  source?: Maybe<Scalars['String']>;
};

export enum PublicSchemaReportDerivativeType {
  Function = 'FUNCTION',
  Script = 'SCRIPT'
}

export type PublicSchemaReportField = {
  __typename?: 'PublicSchemaReportField';
  /** The values allowed within the report, if any. */
  allowedValues: Array<Scalars['String']>;
  /** The "also-known-as" field names. */
  alternateNames: Array<Scalars['String']>;
  /** Indicates the field is auto-generated instead of being processed from input. */
  autogenType?: Maybe<PublicSchemaReportFieldAutogenType>;
  /** The values filtered out from the report, if any. Denied values are taking precedence on allowed values. */
  deniedValues: Array<Scalars['String']>;
  /** The field description. */
  description: Scalars['String'];
  /** The unique identifier. */
  id: Scalars['String'];
  /** The field name. */
  name: Scalars['String'];
  /** The field order. */
  order: Scalars['Int'];
  /** The base-schema output column name. */
  outputColumnName: Scalars['String'];
  /** The base-schema output column type. */
  outputColumnType: Scalars['String'];
  /** The revision number. */
  revision: Scalars['Int'];
  /** The revision change type. */
  revisionType: PublicSchemaReportRevisionType;
  /** The source for the field, if not inlined. */
  sourceType?: Maybe<PublicSchemaReportFieldJoinSourceType>;
  /** The transformations applied to this field. */
  transformations: Array<PublicSchemaReportFieldTransformType>;
};

export enum PublicSchemaReportFieldAutogenType {
  PtNowDay = 'PT_NOW_DAY',
  RecordDump = 'RECORD_DUMP',
  RecordHash = 'RECORD_HASH',
  RecordIndexInInput = 'RECORD_INDEX_IN_INPUT',
  S3ObjectPathL1 = 'S3_OBJECT_PATH_L1',
  S3ObjectPathL2 = 'S3_OBJECT_PATH_L2',
  S3ObjectPathL3 = 'S3_OBJECT_PATH_L3',
  S3ObjectPathL4 = 'S3_OBJECT_PATH_L4',
  S3ObjectPathL5 = 'S3_OBJECT_PATH_L5',
  S3ObjectPathL6 = 'S3_OBJECT_PATH_L6'
}

export enum PublicSchemaReportFieldJoinSourceType {
  JoinSourceA = 'JOIN_SOURCE_A',
  JoinSourceB = 'JOIN_SOURCE_B'
}

export enum PublicSchemaReportFieldTransformType {
  AsCurrencyValue = 'AS_CURRENCY_VALUE',
  ToDateMonth = 'TO_DATE_MONTH',
  ToDateValue = 'TO_DATE_VALUE',
  ToLocale = 'TO_LOCALE',
  ToPercentageValue = 'TO_PERCENTAGE_VALUE'
}

export type PublicSchemaReportIndex = {
  __typename?: 'PublicSchemaReportIndex';
  /** The fields for this index. */
  fields: Array<PublicSchemaReportWithMarketplaceField>;
  /** The unique identifier. */
  id: Scalars['String'];
  /** Indicates whether the index is a unique index. */
  isUnique: Scalars['Boolean'];
  /** The name of the index. */
  name: Scalars['String'];
};

export type PublicSchemaReportPeriod = {
  __typename?: 'PublicSchemaReportPeriod';
  /** Indicates whether backfill is allowed. */
  allowsBackfill: Scalars['Boolean'];
  /** The available history range in units. */
  availableHistoryRange?: Maybe<Scalars['Int']>;
  /** The available history range. */
  availableHistoryRangeUnit?: Maybe<PublicSchemaReportPeriodAvailableHistoryUnit>;
  /** The record unique identifier. */
  id: Scalars['String'];
  /** The period covered. */
  period: PublicSchemaReportCoveredPeriod;
  /** The update frequency override for period, if any. */
  updateFrequency?: Maybe<PublicSchemaReportUpdateFrequency>;
};

export enum PublicSchemaReportPeriodAvailableHistoryUnit {
  Days = 'DAYS',
  Months = 'MONTHS',
  Weeks = 'WEEKS',
  Years = 'YEARS'
}

export type PublicSchemaReportPeriodInput = {
  /** Indicates whether backfill is allowed. */
  allowsBackfill: Scalars['Boolean'];
  /** The available history range in units. */
  availableHistoryRange: Scalars['Int'];
  /** The available history range. */
  availableHistoryRangeUnit: PublicSchemaReportPeriodAvailableHistoryUnit;
  /** The record unique identifier. */
  id: Scalars['String'];
  /** The period covered. */
  period: PublicSchemaReportCoveredPeriod;
  /** The update frequency override for period, if any. */
  updateFrequency?: InputMaybe<PublicSchemaReportUpdateFrequency>;
};

export enum PublicSchemaReportPortalType {
  Adsapi = 'ADSAPI',
  Avn = 'AVN',
  Custom = 'CUSTOM',
  Derivative = 'DERIVATIVE',
  Ecommerce = 'ECOMMERCE',
  Sellerapi = 'SELLERAPI',
  Sellercentral = 'SELLERCENTRAL',
  Sellernotificationapi = 'SELLERNOTIFICATIONAPI',
  Vendorapi = 'VENDORAPI',
  Vendorcentral = 'VENDORCENTRAL',
  Vendornotificationapi = 'VENDORNOTIFICATIONAPI'
}

export enum PublicSchemaReportProcessingType {
  Ingestion = 'INGESTION',
  RunDerivative = 'RUN_DERIVATIVE'
}

export enum PublicSchemaReportRevisionType {
  Delete = 'DELETE',
  Upsert = 'UPSERT'
}

export enum PublicSchemaReportSchemaType {
  Custom = 'CUSTOM',
  Ecommerce = 'ECOMMERCE',
  Public = 'PUBLIC',
  Raw = 'RAW'
}

export type PublicSchemaReportSource = {
  __typename?: 'PublicSchemaReportSource';
  /** The fields for this source. */
  fields: Array<PublicSchemaReportWithMarketplaceField>;
  /** The name of the source. */
  name: Scalars['String'];
  /** The source type. */
  sourceType: PublicSchemaReportFieldJoinSourceType;
};

export type PublicSchemaReportTransformationMarketplace = {
  __typename?: 'PublicSchemaReportTransformationMarketplace';
  /** The marketplaces that we apply this transformation to. */
  marketplace: Marketplace;
  /** The transformation type applied to this marketplace */
  transformation: PublicSchemaReportFieldTransformType;
};

export enum PublicSchemaReportUpdateFrequency {
  Daily = 'DAILY',
  OnDemand = 'ON_DEMAND'
}

export type PublicSchemaReportWithMarketplaceField = {
  __typename?: 'PublicSchemaReportWithMarketplaceField';
  /** The values allowed within the report, if any. */
  allowedValues: Array<Scalars['String']>;
  /** The "also-known-as" field names. */
  alternateNames: Array<Scalars['String']>;
  /** Indicates the field is auto-generated instead of being processed from input. */
  autogenType?: Maybe<PublicSchemaReportFieldAutogenType>;
  /** The values filtered out from the report, if any. Denied values are taking precedence on allowed values. */
  deniedValues: Array<Scalars['String']>;
  /** The field description. */
  description: Scalars['String'];
  /** The unique identifier. */
  id: Scalars['String'];
  /** The marketplaces that the transformations attached to. */
  marketplacesTransformations?: Maybe<Array<PublicSchemaReportTransformationMarketplace>>;
  /** The field name. */
  name: Scalars['String'];
  /** The field order. */
  order: Scalars['Int'];
  /** The base-schema output column name. */
  outputColumnName: Scalars['String'];
  /** The base-schema output column type. */
  outputColumnType: Scalars['String'];
  /** The revision number. */
  revision: Scalars['Int'];
  /** The revision change type. */
  revisionType: PublicSchemaReportRevisionType;
  /** The source for the field, if not inlined. */
  sourceType?: Maybe<PublicSchemaReportFieldJoinSourceType>;
  /** The transformations applied to this field. */
  transformations: Array<PublicSchemaReportFieldTransformType>;
};

export type PublicUser = {
  __typename?: 'PublicUser';
  /** The brands for this user. */
  brands: Array<PublicUserBrand>;
  /** The user email. */
  email: Scalars['String'];
  /** The user identifier. */
  id: Scalars['String'];
  /** The user status. */
  status: PublicUserStatus;
};

export type PublicUserBrand = {
  __typename?: 'PublicUserBrand';
  /** Indicates whether the user can enable/disable reports and buy backfills. */
  canBuy: Scalars['Boolean'];
  /** Indicates whether the user can manage API connections. */
  canManageConnections: Scalars['Boolean'];
  /** Indicates whether the user can read data. */
  canReadData: Scalars['Boolean'];
  /** Indicates whether the user can view reports. */
  canViewDashboards: Scalars['Boolean'];
  /** The brand country. */
  country: Scalars['String'];
  /** The dashboards for the brand and user. */
  dashboards: Array<PublicUserBrandDashboard>;
  /** The internal identifier. */
  id: Scalars['String'];
  /** Indicates whether the user is having account administrative privileges. */
  isAdmin: Scalars['Boolean'];
  /** Indicates whether the user is having billing administrative privileges. */
  isBillingAdmin: Scalars['Boolean'];
  /** The brand name. */
  name: Scalars['String'];
  /** The brand (aka. public partner) identifier. */
  publicPartnerId: Scalars['String'];
  /** The brand's Reason connected partner uuid. */
  reasonPartnerUuid?: Maybe<Scalars['String']>;
  /** The brand type. */
  type: PublicPartnerType;
};

export type PublicUserBrandDashboard = {
  __typename?: 'PublicUserBrandDashboard';
  /** Indicates whether the dashboard is enabled. */
  isEnabled: Scalars['Boolean'];
  /** The dashboard name. */
  name: Scalars['String'];
  /** The seats for this dashboard. */
  seats: Array<PublicUserBrandDashboardSeat>;
};

export type PublicUserBrandDashboardSeat = {
  __typename?: 'PublicUserBrandDashboardSeat';
  /** The public user email the seat is assigned to. */
  assignedToEmail?: Maybe<Scalars['String']>;
  /** The matching public user the seat is assigned to. */
  assignedToPublicUser: Array<Maybe<PublicUser>>;
  /** The seat identifier */
  id: Scalars['String'];
  /** Indicates whether the seat is free of charge */
  isFreeSeat: Scalars['Boolean'];
  /** Indicates whether the seat is marked for cancellation. */
  isSoftCancelled: Scalars['Boolean'];
};

export enum PublicUserStatus {
  Active = 'ACTIVE',
  Invited = 'INVITED'
}

export type PurchaseBrandDashboardSeatPublicUserResult = {
  __typename?: 'PurchaseBrandDashboardSeatPublicUserResult';
  /** The purchase error if any. */
  error?: Maybe<Scalars['String']>;
  /** The purchase error type if any. */
  errorType?: Maybe<Scalars['String']>;
  /** The seat identifier if purchased. */
  id?: Maybe<Scalars['String']>;
  /** The pre-cancellation renew amount to be charged. */
  renewAmount?: Maybe<Scalars['Float']>;
  /** The pre-cancellation renew currency to be charged. */
  renewAmountCurrency?: Maybe<StripeCurrencyType>;
  /** The pre-cancellation renew period type. */
  renewPeriodType?: Maybe<StripePeriodType>;
};

export type Query = {
  __typename?: 'Query';
  /** Describes the application deployment */
  _appData?: Maybe<AppData>;
  /** Get the LWA public client ids used by this application. */
  clientIds: LwaClientIdsResponse;
  /** Retrieve an Advertising partner's advertising profiles. */
  getAdvertisingProfiles: Array<AdvertisingProfile>;
  /** Get the Stripe billing information for a given public partner. */
  getBillingInformationStripe?: Maybe<StripeBillingInformation>;
  /** Get the Stripe invoice history for a given public partner. */
  getInvoiceHistoryStripe: Array<StripeInvoice>;
  /** Get all Stripe payment methods for a given public partner. */
  getPaymentMethodsStripe: Array<StripePaymentMethod>;
  /** Get all Stripe plans for a given public partner. */
  getPlanInformationStripe?: Maybe<StripePlanInformation>;
  /** Get a given public user managed by the current user. */
  getPublicUser?: Maybe<PublicUser>;
  /** List all backfills. */
  listBackfills: Array<BackfillStatus>;
  /** List all data tables for a given public partner. */
  listDataTables: Array<PublicPartnerDataTable>;
  /** Gets all data report nodes for a given partner. */
  listNodesData: Array<DataReportNode>;
  /** Returns the matching partner, if any. */
  listPowerBIReportPages: Array<PowerBiReportPage>;
  /** Get the list of public users managed by the current user. */
  listPublicUsers: Array<PublicUser>;
  marketplaceUrl?: Maybe<MarketplaceUrl>;
  marketplaceUrls: Array<MarketplaceUrl>;
  /** Returns new partner onboarding checklist. */
  newPartnerOnboardingChecklist?: Maybe<PublicPortalChecklist>;
  /** Returns the matching partner, if any. */
  publicPartner?: Maybe<PublicPartner>;
  /** Returns the matching partner credentials, if any. */
  publicPartnerCredentials: Array<PublicPartnerCredentials>;
  /** Returns the matching partner dashboard, if any. */
  publicPartnerDashboard?: Maybe<PublicUserBrandDashboard>;
  /** List all public partners. */
  publicPartners: Array<PublicPartner>;
  /** List all schema reports. */
  schemaReports: Array<PublicSchemaReport>;
};


export type QueryGetAdvertisingProfilesArgs = {
  partnerId: Scalars['String'];
};


export type QueryGetBillingInformationStripeArgs = {
  partnerId: Scalars['String'];
};


export type QueryGetInvoiceHistoryStripeArgs = {
  partnerId: Scalars['String'];
};


export type QueryGetPaymentMethodsStripeArgs = {
  partnerId: Scalars['String'];
};


export type QueryGetPlanInformationStripeArgs = {
  partnerId: Scalars['String'];
};


export type QueryGetPublicUserArgs = {
  id: Scalars['String'];
};


export type QueryListBackfillsArgs = {
  publicPartnerId: Scalars['String'];
};


export type QueryListDataTablesArgs = {
  publicPartnerId: Scalars['String'];
};


export type QueryListNodesDataArgs = {
  partnerId?: InputMaybe<Scalars['String']>;
};


export type QueryListPowerBiReportPagesArgs = {
  groupId: Scalars['String'];
  reportId: Scalars['String'];
};


export type QueryMarketplaceUrlArgs = {
  where: MarketplaceUrlWhereUniqueInput;
};


export type QueryMarketplaceUrlsArgs = {
  after?: InputMaybe<MarketplaceUrlWhereUniqueInput>;
  before?: InputMaybe<MarketplaceUrlWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MarketplaceUrlOrderByWithRelationInput>>;
  where?: InputMaybe<MarketplaceUrlWhereInput>;
};


export type QueryNewPartnerOnboardingChecklistArgs = {
  partnerId?: InputMaybe<Scalars['String']>;
};


export type QueryPublicPartnerArgs = {
  partnerId: Scalars['String'];
};


export type QueryPublicPartnerCredentialsArgs = {
  partnerId: Scalars['String'];
};


export type QueryPublicPartnerDashboardArgs = {
  name: Scalars['String'];
  partnerId: Scalars['String'];
};


export type QuerySchemaReportsArgs = {
  nameFragment?: InputMaybe<Scalars['String']>;
  portalType?: InputMaybe<PublicSchemaReportPortalType>;
  reportProcessingType?: InputMaybe<PublicSchemaReportProcessingType>;
  tableNames?: InputMaybe<Array<Scalars['String']>>;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type RecognizePublicPartnerResult = {
  __typename?: 'RecognizePublicPartnerResult';
  /** A recognizable account id, if available */
  accountId?: Maybe<Scalars['String']>;
  /** A recognizable account name, if available */
  accountName?: Maybe<Scalars['String']>;
  /** Some campaigns from the account. Only available for ads accounts */
  campaigns?: Maybe<AdsCampaignSample>;
  /** A recognizable entity id, if available */
  entityId?: Maybe<Scalars['String']>;
  /** Account marketplaces */
  marketPlaces: Array<Scalars['String']>;
  /** Some items from the account. Only available for sellers. */
  sellerItems?: Maybe<Array<SellerItemSample>>;
  /** account id */
  token: Scalars['String'];
  /** Some orders from the account. Only available for vendors. */
  vendorOrders?: Maybe<Array<VendorOrderSample>>;
};

export enum ReportDateFormatType {
  Date = 'DATE',
  DateTime = 'DATE_TIME',
  DateWithHour = 'DATE_with_HOUR',
  None = 'NONE'
}

export enum ReportFileType {
  Csv = 'CSV',
  Json = 'JSON',
  Jsonl = 'JSONL',
  Tsv = 'TSV',
  Xls = 'XLS',
  Xlsx = 'XLSX',
  Xml = 'XML'
}

export enum ReportGroupType {
  Custom = 'custom',
  Ecommerce = 'ecommerce',
  Seller = 'seller',
  Vendor = 'vendor'
}

export enum ReportProviderType {
  Amazon = 'amazon'
}

export type SellerItemSample = {
  __typename?: 'SellerItemSample';
  /** Item ASIN */
  asin: Scalars['String'];
  /** Amazon URI for the ASIN, if available */
  asinUri?: Maybe<Scalars['String']>;
  /** Item brand if available */
  brand: Scalars['String'];
  /** Item name if available */
  name: Scalars['String'];
  /** Item SKU if available */
  sku: Scalars['String'];
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SortOrderInput = {
  nulls?: InputMaybe<NullsOrder>;
  sort: SortOrder;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StripeBillingInformation = {
  __typename?: 'StripeBillingInformation';
  /** Address line 1 (e.g., street, block, PO Box, or company name). */
  addressLine1?: Maybe<Scalars['String']>;
  /** Address line 2 (e.g., apartment, suite, unit, or building). */
  addressLine2?: Maybe<Scalars['String']>;
  /** City, district, suburb, town, village, or ward. */
  city?: Maybe<Scalars['String']>;
  /** Two-letter country code (ISO 3166-1 alpha-2). */
  countryCode?: Maybe<Scalars['String']>;
  /** The customer's full name or business name. */
  name: Scalars['String'];
  /** The customer's phone number. */
  phoneNumber?: Maybe<Scalars['String']>;
  /** ZIP or postal code. */
  postalCode?: Maybe<Scalars['String']>;
  /** State, county, province, prefecture, or region. */
  state?: Maybe<Scalars['String']>;
};

export type StripeBillingInformationInput = {
  /** Address line 1 (e.g., street, block, PO Box, or company name). */
  addressLine1?: InputMaybe<Scalars['String']>;
  /** Address line 2 (e.g., apartment, suite, unit, or building). */
  addressLine2?: InputMaybe<Scalars['String']>;
  /** City, district, suburb, town, village, or ward. */
  city?: InputMaybe<Scalars['String']>;
  /** Two-letter country code (ISO 3166-1 alpha-2). */
  countryCode?: InputMaybe<Scalars['String']>;
  /** The customer's full name or business name. */
  name: Scalars['String'];
  /** The customer's phone number. */
  phoneNumber?: InputMaybe<Scalars['String']>;
  /** ZIP or postal code. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** State, county, province, prefecture, or region. */
  state?: InputMaybe<Scalars['String']>;
};

export enum StripeCurrencyType {
  Usd = 'USD'
}

export type StripeInvoice = {
  __typename?: 'StripeInvoice';
  /** The public name of the business associated with this invoice, most often the business creating the invoice. */
  accountName?: Maybe<Scalars['String']>;
  /** Final amount due at this time for this invoice. */
  amount: Scalars['Float'];
  /** The amount, in cents, that was paid. */
  amountPaid: Scalars['Float'];
  /** For ACH Bank Account as payment method, the last 4 digits of the account number. */
  bankAccountLast4?: Maybe<Scalars['String']>;
  /** For ACH Bank Account as payment method, the account type. */
  bankAccountType?: Maybe<Scalars['String']>;
  /** For ACH Bank Account as payment method, the bank name. */
  bankName?: Maybe<Scalars['String']>;
  /** For Credit Card as payment method, the expiration month of the card. */
  cardExpirationMonth?: Maybe<Scalars['Int']>;
  /** For Credit Card as payment method, the expiration year of the card. */
  cardExpirationYear?: Maybe<Scalars['Int']>;
  /** For Credit Card as payment method, the last 4 digits of the card. */
  cardLast4?: Maybe<Scalars['String']>;
  /** For Credit Card as payment method, the card type. */
  cardType?: Maybe<Scalars['String']>;
  /** Three-letter ISO currency code,. */
  currency: StripeCurrencyType;
  /** The customer's name. */
  customerName?: Maybe<Scalars['String']>;
  /** The date on which payment for this invoice is due. */
  dueDate?: Maybe<Scalars['String']>;
  /** Unique identifier for the object. */
  id: Scalars['String'];
  /** A unique, identifying string that appears on emails sent to the customer for this invoice. */
  invoiceNumber?: Maybe<Scalars['String']>;
  /** The link to download the PDF for the invoice. */
  invoicePdf?: Maybe<Scalars['String']>;
  /** ID of the default payment method for the invoice. */
  paymentMethodId?: Maybe<Scalars['String']>;
  /** The payment method type. */
  paymentMethodType?: Maybe<Scalars['String']>;
  /** End of the usage period during which invoice items were added to this invoice.. */
  periodEnd: Scalars['String'];
  /** Start of the usage period during which invoice items were added to this invoice. */
  periodStart: Scalars['String'];
  /** This is the transaction number that appears on email receipts sent for this invoice. */
  receiptNumber?: Maybe<Scalars['String']>;
  /** This is the URL to view the receipt for this invoice. */
  receiptUrl?: Maybe<Scalars['String']>;
  /** The status of the invoice. */
  status?: Maybe<StripeInvoiceStatus>;
};

export enum StripeInvoiceStatus {
  Draft = 'draft',
  Open = 'open',
  Paid = 'paid',
  Uncollectible = 'uncollectible',
  Void = 'void'
}

export type StripePaymentMethod = {
  __typename?: 'StripePaymentMethod';
  /** For ACH Bank Account as payment method, the last 4 digits of the account number. */
  bankAccountLast4?: Maybe<Scalars['String']>;
  /** For ACH Bank Account as payment method, the account type. */
  bankAccountType?: Maybe<Scalars['String']>;
  /** For ACH Bank Account as payment method, the bank name. */
  bankName?: Maybe<Scalars['String']>;
  /** For Credit Card as payment method, the expiration month of the card. */
  cardExpirationMonth?: Maybe<Scalars['Int']>;
  /** For Credit Card as payment method, the expiration year of the card. */
  cardExpirationYear?: Maybe<Scalars['Int']>;
  /** For Credit Card as payment method, the last 4 digits of the card. */
  cardLast4?: Maybe<Scalars['String']>;
  /** For Credit Card as payment method, the card type. */
  cardType?: Maybe<Scalars['String']>;
  /** Indicates whether the payment method is marked as default payment method. */
  isDefault: Scalars['Boolean'];
  /** For Link as payment method, the email associated with the account. */
  linkEmail?: Maybe<Scalars['String']>;
  /** The Stripe identifier for the payment method. */
  paymentMethodId: Scalars['String'];
  /** The payment method type. */
  type: Scalars['String'];
};

export enum StripePeriodType {
  Daily = 'Daily',
  Monthly = 'Monthly',
  Weekly = 'Weekly',
  Yearly = 'Yearly'
}

export type StripePlanInformation = {
  __typename?: 'StripePlanInformation';
  /** For ACH Bank Account as payment method, the last 4 digits of the account number. */
  bankAccountLast4?: Maybe<Scalars['String']>;
  /** For ACH Bank Account as payment method, the account type. */
  bankAccountType?: Maybe<Scalars['String']>;
  /** For ACH Bank Account as payment method, the bank name. */
  bankName?: Maybe<Scalars['String']>;
  /** For Credit Card as payment method, the expiration month of the card. */
  cardExpirationMonth?: Maybe<Scalars['Int']>;
  /** For Credit Card as payment method, the expiration year of the card. */
  cardExpirationYear?: Maybe<Scalars['Int']>;
  /** For Credit Card as payment method, the last 4 digits of the card. */
  cardLast4?: Maybe<Scalars['String']>;
  /** For Credit Card as payment method, the card type. */
  cardType?: Maybe<Scalars['String']>;
  /** The payment method identifier to be used for next renew. */
  renewUsingPaymentMethodId?: Maybe<Scalars['String']>;
  /** The payment method type. */
  renewUsingPaymentMethodType?: Maybe<Scalars['String']>;
  /** All seats purchased */
  seats: Array<StripePlanInformationSeat>;
  /** All seats purchased */
  subscriptions: Array<StripePlanInformationSubscription>;
};

export type StripePlanInformationSeat = {
  __typename?: 'StripePlanInformationSeat';
  /** The brand. */
  brand: PublicUserBrand;
  /** The brand dashboard. */
  brandDashboard: PublicUserBrandDashboard;
  /** The brand dashboard seat. */
  brandDashboardSeat: PublicUserBrandDashboardSeat;
  /** Indicates whether the seat is marked for cancellation. */
  isSoftCancelled: Scalars['Boolean'];
  /** The plan name. */
  name: Scalars['String'];
  /** The renew amount to be charged. */
  renewAmount?: Maybe<Scalars['Float']>;
  /** The renew currency to be charged. */
  renewAmountCurrency?: Maybe<StripeCurrencyType>;
  /** When the next renew will occur. */
  renewOn?: Maybe<Scalars['String']>;
  /** The renew period type. */
  renewPeriodType?: Maybe<StripePeriodType>;
};

export type StripePlanInformationSubscription = {
  __typename?: 'StripePlanInformationSubscription';
  /** The plan name. */
  name: Scalars['String'];
  /** The product identifier. */
  productId?: Maybe<Scalars['String']>;
  /** The renew amount to be charged. */
  renewAmount?: Maybe<Scalars['Float']>;
  /** The renew currency to be charged. */
  renewAmountCurrency?: Maybe<StripeCurrencyType>;
  /** When the next renew will occur. */
  renewOn?: Maybe<Scalars['String']>;
  /** The renew period type. */
  renewPeriodType?: Maybe<StripePeriodType>;
};

export type StripePurchase = {
  __typename?: 'StripePurchase';
  /** The amount charged in given currency. */
  amount: Scalars['Int'];
  /** The Stripe charge identifier for this purchase. */
  chargeId: Scalars['String'];
  /** The currency used. */
  currency: StripeCurrencyType;
  /** The Stripe purchase receipt for this purchase if available. */
  purchaseReceipt?: Maybe<Scalars['String']>;
  /** The Stripe purchase receipt url for this purchase. */
  purchaseReceiptUrl: Scalars['String'];
  /** The purchase type completed. */
  purchaseType: StripePurchaseType;
};

export enum StripePurchaseType {
  Usd_5_99 = 'USD_5_99',
  UsdBackfills = 'USD_BACKFILLS'
}

export type StripeSetupIntent = {
  __typename?: 'StripeSetupIntent';
  /** The client secret for the payment intent. */
  clientSecret: Scalars['String'];
};

export type UpdateGoogleSheetsPlanPublicPartnerResult = {
  __typename?: 'UpdateGoogleSheetsPlanPublicPartnerResult';
  /** The plan identifier if purchased. */
  id?: Maybe<Scalars['String']>;
  /** The pre-cancellation renew amount to be charged. */
  renewAmount?: Maybe<Scalars['Float']>;
  /** The pre-cancellation renew currency to be charged. */
  renewAmountCurrency?: Maybe<StripeCurrencyType>;
  /** The pre-cancellation renew period type. */
  renewPeriodType?: Maybe<StripePeriodType>;
};

export type VendorOrderSample = {
  __typename?: 'VendorOrderSample';
  /** Item ASIN */
  asin: Scalars['String'];
  /** Amazon URI for the ASIN, if available */
  asinUri?: Maybe<Scalars['String']>;
  /** Order Date */
  orderDate: Scalars['String'];
  /** Order Number */
  orderNumber: Scalars['String'];
};

export type StripeSetupIntentMutationVariables = Exact<{
  partnerId: Scalars['String'];
}>;


export type StripeSetupIntentMutation = { __typename?: 'Mutation', setupIntentStripe?: { __typename?: 'StripeSetupIntent', clientSecret: string } | null };

export type StripeGetPaymentMethodsQueryVariables = Exact<{
  partnerId: Scalars['String'];
}>;


export type StripeGetPaymentMethodsQuery = { __typename?: 'Query', getPaymentMethodsStripe: Array<{ __typename?: 'StripePaymentMethod', type: string, paymentMethodId: string, isDefault: boolean, cardType?: string | null, cardLast4?: string | null, cardExpirationYear?: number | null, cardExpirationMonth?: number | null, bankName?: string | null, bankAccountType?: string | null, bankAccountLast4?: string | null, linkEmail?: string | null }> };

export type StripeAddPaymentMethodMutationVariables = Exact<{
  partnerId: Scalars['String'];
  paymentMethodId: Scalars['String'];
}>;


export type StripeAddPaymentMethodMutation = { __typename?: 'Mutation', addPaymentMethodStripe: boolean };

export type StripeRemovePaymentMethodMutationVariables = Exact<{
  partnerId: Scalars['String'];
  paymentMethodId: Scalars['String'];
}>;


export type StripeRemovePaymentMethodMutation = { __typename?: 'Mutation', removePaymentMethodStripe: boolean };

export type StripeRemoveAllPaymentMethodMutationVariables = Exact<{
  partnerId: Scalars['String'];
}>;


export type StripeRemoveAllPaymentMethodMutation = { __typename?: 'Mutation', removeAllPaymentMethodsStripe: boolean };

export type StripeSetPaymentMethodAsDefaultMutationVariables = Exact<{
  partnerId: Scalars['String'];
  paymentMethodId: Scalars['String'];
}>;


export type StripeSetPaymentMethodAsDefaultMutation = { __typename?: 'Mutation', setPaymentMethodAsDefaultStripe: boolean };

export type StripePurchaseMutationVariables = Exact<{
  partnerId: Scalars['String'];
  purchaseType: StripePurchaseType;
  paymentMethodId: Scalars['String'];
}>;


export type StripePurchaseMutation = { __typename?: 'Mutation', purchaseStripe: { __typename?: 'StripePurchase', purchaseType: StripePurchaseType, amount: number, currency: StripeCurrencyType } };

export type StripeGetPlanInformationQueryVariables = Exact<{
  partnerId: Scalars['String'];
}>;


export type StripeGetPlanInformationQuery = { __typename?: 'Query', getPlanInformationStripe?: { __typename?: 'StripePlanInformation', renewUsingPaymentMethodId?: string | null, renewUsingPaymentMethodType?: string | null, cardType?: string | null, cardLast4?: string | null, cardExpirationMonth?: number | null, cardExpirationYear?: number | null, bankAccountType?: string | null, bankAccountLast4?: string | null, bankName?: string | null, subscriptions: Array<{ __typename?: 'StripePlanInformationSubscription', name: string, renewOn?: string | null, renewAmount?: number | null, renewPeriodType?: StripePeriodType | null, renewAmountCurrency?: StripeCurrencyType | null }>, seats: Array<{ __typename?: 'StripePlanInformationSeat', name: string, renewOn?: string | null, renewAmount?: number | null, renewPeriodType?: StripePeriodType | null, renewAmountCurrency?: StripeCurrencyType | null, brand: { __typename?: 'PublicUserBrand', publicPartnerId: string, name: string }, brandDashboard: { __typename?: 'PublicUserBrandDashboard', name: string }, brandDashboardSeat: { __typename?: 'PublicUserBrandDashboardSeat', id: string, isSoftCancelled: boolean, isFreeSeat: boolean, assignedToEmail?: string | null, assignedToPublicUser: Array<{ __typename?: 'PublicUser', id: string, email: string } | null> } }> } | null };

export type PlanSubscriptionFragment = { __typename?: 'StripePlanInformationSubscription', name: string, renewOn?: string | null, renewAmount?: number | null, renewPeriodType?: StripePeriodType | null, renewAmountCurrency?: StripeCurrencyType | null };

export type PlanSeatFragment = { __typename?: 'StripePlanInformationSeat', name: string, renewOn?: string | null, renewAmount?: number | null, renewPeriodType?: StripePeriodType | null, renewAmountCurrency?: StripeCurrencyType | null, brand: { __typename?: 'PublicUserBrand', publicPartnerId: string, name: string }, brandDashboard: { __typename?: 'PublicUserBrandDashboard', name: string }, brandDashboardSeat: { __typename?: 'PublicUserBrandDashboardSeat', id: string, isSoftCancelled: boolean, isFreeSeat: boolean, assignedToEmail?: string | null, assignedToPublicUser: Array<{ __typename?: 'PublicUser', id: string, email: string } | null> } };

export type StripeCancelPlanMutationVariables = Exact<{
  partnerId: Scalars['String'];
}>;


export type StripeCancelPlanMutation = { __typename?: 'Mutation', cancelPlanStripe: boolean };

export type StripeGetPublicPartnerDashboardQueryVariables = Exact<{
  partnerId: Scalars['String'];
  name: Scalars['String'];
}>;


export type StripeGetPublicPartnerDashboardQuery = { __typename?: 'Query', publicPartnerDashboard?: { __typename?: 'PublicUserBrandDashboard', name: string, isEnabled: boolean, seats: Array<{ __typename?: 'PublicUserBrandDashboardSeat', id: string, isSoftCancelled: boolean, isFreeSeat: boolean, assignedToEmail?: string | null, assignedToPublicUser: Array<{ __typename?: 'PublicUser', id: string, email: string } | null> }> } | null };

export type PpPublicPartnerUserFragment = { __typename?: 'PublicPartnerUser', id: string, email: string, status: PublicUserStatus, canReadData: boolean };

export type PpGetPublicPartnerUsersQueryVariables = Exact<{
  partnerId: Scalars['String'];
}>;


export type PpGetPublicPartnerUsersQuery = { __typename?: 'Query', publicPartner?: { __typename?: 'PublicPartner', users?: Array<{ __typename?: 'PublicPartnerUser', id: string, email: string, status: PublicUserStatus, canReadData: boolean }> | null } | null };

export type StripeGetBillingInformationQueryVariables = Exact<{
  partnerId: Scalars['String'];
}>;


export type StripeGetBillingInformationQuery = { __typename?: 'Query', getBillingInformationStripe?: { __typename?: 'StripeBillingInformation', name: string, phoneNumber?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, postalCode?: string | null, state?: string | null, countryCode?: string | null } | null };

export type StripeSetBillingInformationMutationVariables = Exact<{
  partnerId: Scalars['String'];
  name: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
}>;


export type StripeSetBillingInformationMutation = { __typename?: 'Mutation', setBillingInformationStripe: boolean };

export type StripeGetInvoiceHistoryQueryVariables = Exact<{
  partnerId: Scalars['String'];
}>;


export type StripeGetInvoiceHistoryQuery = { __typename?: 'Query', getInvoiceHistoryStripe: Array<{ __typename?: 'StripeInvoice', id: string, invoiceNumber?: string | null, receiptNumber?: string | null, dueDate?: string | null, periodStart: string, periodEnd: string, invoicePdf?: string | null, status?: StripeInvoiceStatus | null, currency: StripeCurrencyType, amount: number, amountPaid: number, accountName?: string | null, customerName?: string | null, paymentMethodId?: string | null, receiptUrl?: string | null, cardType?: string | null, cardLast4?: string | null, cardExpirationMonth?: number | null, cardExpirationYear?: number | null, bankAccountType?: string | null, bankAccountLast4?: string | null, bankName?: string | null }> };

export type PublicUserBrandDashboardSeatFragmentFragment = { __typename?: 'PublicUserBrandDashboardSeat', id: string, isSoftCancelled: boolean, isFreeSeat: boolean, assignedToEmail?: string | null, assignedToPublicUser: Array<{ __typename?: 'PublicUser', id: string, email: string } | null> };

export type PublicUserBrandDashboardFragmentFragment = { __typename?: 'PublicUserBrandDashboard', name: string, isEnabled: boolean, seats: Array<{ __typename?: 'PublicUserBrandDashboardSeat', id: string, isSoftCancelled: boolean, isFreeSeat: boolean, assignedToEmail?: string | null, assignedToPublicUser: Array<{ __typename?: 'PublicUser', id: string, email: string } | null> }> };

export type PublicUserBrandFragmentFragment = { __typename?: 'PublicUserBrand', id: string, publicPartnerId: string, name: string, reasonPartnerUuid?: string | null, type: PublicPartnerType, country: string, canReadData: boolean, canViewDashboards: boolean, canManageConnections: boolean, canBuy: boolean, isAdmin: boolean, isBillingAdmin: boolean, dashboards: Array<{ __typename?: 'PublicUserBrandDashboard', name: string, isEnabled: boolean, seats: Array<{ __typename?: 'PublicUserBrandDashboardSeat', id: string, isSoftCancelled: boolean, isFreeSeat: boolean, assignedToEmail?: string | null, assignedToPublicUser: Array<{ __typename?: 'PublicUser', id: string, email: string } | null> }> }> };

export type PublicUserFragmentFragment = { __typename?: 'PublicUser', id: string, email: string, status: PublicUserStatus, brands: Array<{ __typename?: 'PublicUserBrand', id: string, publicPartnerId: string, name: string, reasonPartnerUuid?: string | null, type: PublicPartnerType, country: string, canReadData: boolean, canViewDashboards: boolean, canManageConnections: boolean, canBuy: boolean, isAdmin: boolean, isBillingAdmin: boolean, dashboards: Array<{ __typename?: 'PublicUserBrandDashboard', name: string, isEnabled: boolean, seats: Array<{ __typename?: 'PublicUserBrandDashboardSeat', id: string, isSoftCancelled: boolean, isFreeSeat: boolean, assignedToEmail?: string | null, assignedToPublicUser: Array<{ __typename?: 'PublicUser', id: string, email: string } | null> }> }> }> };

export type UserManagementPublicUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type UserManagementPublicUsersQuery = { __typename?: 'Query', listPublicUsers: Array<{ __typename?: 'PublicUser', id: string, email: string, status: PublicUserStatus, brands: Array<{ __typename?: 'PublicUserBrand', id: string, publicPartnerId: string, name: string, reasonPartnerUuid?: string | null, type: PublicPartnerType, country: string, canReadData: boolean, canViewDashboards: boolean, canManageConnections: boolean, canBuy: boolean, isAdmin: boolean, isBillingAdmin: boolean, dashboards: Array<{ __typename?: 'PublicUserBrandDashboard', name: string, isEnabled: boolean, seats: Array<{ __typename?: 'PublicUserBrandDashboardSeat', id: string, isSoftCancelled: boolean, isFreeSeat: boolean, assignedToEmail?: string | null, assignedToPublicUser: Array<{ __typename?: 'PublicUser', id: string, email: string } | null> }> }> }> }> };

export type UserManagementGetPublicUserQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type UserManagementGetPublicUserQuery = { __typename?: 'Query', getPublicUser?: { __typename?: 'PublicUser', id: string, email: string, status: PublicUserStatus, brands: Array<{ __typename?: 'PublicUserBrand', id: string, publicPartnerId: string, name: string, reasonPartnerUuid?: string | null, type: PublicPartnerType, country: string, canReadData: boolean, canViewDashboards: boolean, canManageConnections: boolean, canBuy: boolean, isAdmin: boolean, isBillingAdmin: boolean, dashboards: Array<{ __typename?: 'PublicUserBrandDashboard', name: string, isEnabled: boolean, seats: Array<{ __typename?: 'PublicUserBrandDashboardSeat', id: string, isSoftCancelled: boolean, isFreeSeat: boolean, assignedToEmail?: string | null, assignedToPublicUser: Array<{ __typename?: 'PublicUser', id: string, email: string } | null> }> }> }> } | null };

export type UserManagementAddPublicUserMutationVariables = Exact<{
  name: Scalars['String'];
  email: Scalars['String'];
  brands: Array<AddPublicUserBrandInput> | AddPublicUserBrandInput;
}>;


export type UserManagementAddPublicUserMutation = { __typename?: 'Mutation', addPublicUser: boolean };

export type UserManagementRemovePublicUserMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type UserManagementRemovePublicUserMutation = { __typename?: 'Mutation', removePublicUser: boolean };

export type UserManagementReinvitePublicUserMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type UserManagementReinvitePublicUserMutation = { __typename?: 'Mutation', reinvitePublicUser: boolean };

export type UserManagementSetBrandPermissionsPublicUserMutationVariables = Exact<{
  userId: Scalars['String'];
  brandId: Scalars['String'];
  isAdmin: Scalars['Boolean'];
  isBillingAdmin: Scalars['Boolean'];
  canBuy: Scalars['Boolean'];
  canManageConnections: Scalars['Boolean'];
  canViewDashboards: Scalars['Boolean'];
  canReadData: Scalars['Boolean'];
}>;


export type UserManagementSetBrandPermissionsPublicUserMutation = { __typename?: 'Mutation', setBrandPermissionsPublicUser: boolean };

export type UserManagementAssignBrandDashboardSeatPublicUserMutationVariables = Exact<{
  userId: Scalars['String'];
  brandId: Scalars['String'];
  dashboardName: Scalars['String'];
}>;


export type UserManagementAssignBrandDashboardSeatPublicUserMutation = { __typename?: 'Mutation', assignBrandDashboardSeatPublicUser?: boolean | null };

export type UserManagementUnassignBrandDashboardSeatPublicUserMutationVariables = Exact<{
  userId: Scalars['String'];
  brandId: Scalars['String'];
  dashboardName: Scalars['String'];
}>;


export type UserManagementUnassignBrandDashboardSeatPublicUserMutation = { __typename?: 'Mutation', unassignBrandDashboardSeatPublicUser?: boolean | null };

export type UserManagementPurchaseBrandDashboardSeatPublicUserMutationVariables = Exact<{
  brandId: Scalars['String'];
  dashboardName: Scalars['String'];
  evalOnly: Scalars['Boolean'];
}>;


export type UserManagementPurchaseBrandDashboardSeatPublicUserMutation = { __typename?: 'Mutation', purchaseBrandDashboardSeatPublicUser: { __typename?: 'PurchaseBrandDashboardSeatPublicUserResult', id?: string | null, error?: string | null, errorType?: string | null, renewAmount?: number | null, renewPeriodType?: StripePeriodType | null, renewAmountCurrency?: StripeCurrencyType | null } };

export type UserManagementCancelBrandDashboardSeatPublicUserMutationVariables = Exact<{
  brandId: Scalars['String'];
  dashboardName: Scalars['String'];
  id: Scalars['String'];
  evalOnly: Scalars['Boolean'];
}>;


export type UserManagementCancelBrandDashboardSeatPublicUserMutation = { __typename?: 'Mutation', cancelBrandDashboardSeatPublicUser: { __typename?: 'CancelBrandDashboardSeatPublicUserResult', id: string, renewAmount?: number | null, renewPeriodType?: StripePeriodType | null, renewAmountCurrency?: StripeCurrencyType | null, cancelOn?: string | null, didCancel: boolean } };

export type GetLwaClientIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLwaClientIdQuery = { __typename?: 'Query', clientIds: { __typename?: 'LwaClientIdsResponse', advertisingClientId: string, sellerVendorClientId: string } };

export type PpListBackfillsQueryVariables = Exact<{
  publicPartnerId: Scalars['String'];
}>;


export type PpListBackfillsQuery = { __typename?: 'Query', listBackfills: Array<{ __typename?: 'BackfillStatus', id: string, status: BackfillStatusType, percentageCompletion?: number | null, startedAt?: string | null, lastUpdatedOn: string, requesterEmail: string, requestedBy: BackfillStatusRequestedByType, reports: Array<{ __typename?: 'BackfillStatusReport', id: string, reportName: string, description?: string | null, outputTableName: string, outputSchemaType: PublicSchemaReportSchemaType, publicSchema?: { __typename?: 'PublicSchemaReport', reasonAutomationHelpUrl?: string | null } | null, requestedPeriods: Array<{ __typename?: 'BackfillStatusReportPeriod', id: string, period: PublicSchemaReportCoveredPeriod, backfillStartDate?: string | null, backfillEndDate?: string | null }> }> }> };

export type RecognizePublicPartnerMutationVariables = Exact<{
  code: Scalars['String'];
  redirectUri: Scalars['String'];
  marketplace: Scalars['String'];
  accountType: PublicPartnerType;
  sellingPartnerId?: InputMaybe<Scalars['String']>;
  adsProfileId?: InputMaybe<Scalars['String']>;
}>;


export type RecognizePublicPartnerMutation = { __typename?: 'Mutation', recognizePublicPartner: { __typename?: 'RecognizePublicPartnerResult', accountId?: string | null, entityId?: string | null, accountName?: string | null, marketPlaces: Array<string>, token: string, sellerItems?: Array<{ __typename?: 'SellerItemSample', asin: string, asinUri?: string | null, sku: string, name: string, brand: string }> | null, vendorOrders?: Array<{ __typename?: 'VendorOrderSample', asin: string, asinUri?: string | null, orderDate: string, orderNumber: string }> | null, campaigns?: { __typename?: 'AdsCampaignSample', spCampaigns: Array<string>, sbCampaigns: Array<string>, sdCampaigns: Array<string> } | null } };

export type SelectAdvertisingProfileMutationVariables = Exact<{
  partnerId: Scalars['String'];
  advertisingProfileId: Scalars['String'];
}>;


export type SelectAdvertisingProfileMutation = { __typename?: 'Mutation', selectAdvertisingProfile: boolean };

export type GetAdvertisingProfilesQueryVariables = Exact<{
  partnerId: Scalars['String'];
}>;


export type GetAdvertisingProfilesQuery = { __typename?: 'Query', getAdvertisingProfiles: Array<{ __typename?: 'AdvertisingProfile', id: string, name: string, type: string, countryCode: string }> };

export type CreatePartnerMutationVariables = Exact<{
  partner: PublicPartnerInput;
}>;


export type CreatePartnerMutation = { __typename?: 'Mutation', createPublicPartner: { __typename?: 'PublicPartner', advertisingProfileId?: string | null, createdAt: any, id: string, isConnected: boolean, connectedStatus: PublicPartnerConnectionStatus, marketplace: Marketplace, name: string, friendlyName?: string | null, type: PublicPartnerType, reasonPartnerName?: string | null, reasonPartnerUuid?: string | null, canBeDeleted: boolean } };

export type UpdatePartnerMutationVariables = Exact<{
  partnerId: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  friendlyName?: InputMaybe<Scalars['String']>;
}>;


export type UpdatePartnerMutation = { __typename?: 'Mutation', updatePublicPartner?: { __typename?: 'PublicPartner', advertisingProfileId?: string | null, createdAt: any, id: string, isConnected: boolean, connectedStatus: PublicPartnerConnectionStatus, marketplace: Marketplace, name: string, friendlyName?: string | null, type: PublicPartnerType, reasonPartnerName?: string | null, reasonPartnerUuid?: string | null, canBeDeleted: boolean } | null };

export type PpGenerateSystemReportForPpPartnerMutationVariables = Exact<{
  partnerId: Scalars['String'];
}>;


export type PpGenerateSystemReportForPpPartnerMutation = { __typename?: 'Mutation', generateSystemReports: boolean };

export type ConnectPartnerMutationMutationVariables = Exact<{
  code: Scalars['String'];
  partnerId: Scalars['String'];
  redirectUri: Scalars['String'];
  sellingPartnerId: Scalars['String'];
  refreshToken?: InputMaybe<Scalars['String']>;
}>;


export type ConnectPartnerMutationMutation = { __typename?: 'Mutation', connectPublicPartner: boolean };

export type ConnectAdvertisingMutationVariables = Exact<{
  partnerId: Scalars['String'];
  code: Scalars['String'];
  redirectUri: Scalars['String'];
}>;


export type ConnectAdvertisingMutation = { __typename?: 'Mutation', connectAdvertisingPublicPartner: boolean };

export type PublicPartnerFragmentFragment = { __typename?: 'PublicPartner', advertisingProfileId?: string | null, createdAt: any, id: string, isConnected: boolean, connectedStatus: PublicPartnerConnectionStatus, marketplace: Marketplace, name: string, friendlyName?: string | null, type: PublicPartnerType, reasonPartnerName?: string | null, reasonPartnerUuid?: string | null, canBeDeleted: boolean };

export type PublicPartnersQueryVariables = Exact<{ [key: string]: never; }>;


export type PublicPartnersQuery = { __typename?: 'Query', publicPartners: Array<{ __typename?: 'PublicPartner', advertisingProfileId?: string | null, createdAt: any, id: string, isConnected: boolean, connectedStatus: PublicPartnerConnectionStatus, marketplace: Marketplace, name: string, friendlyName?: string | null, type: PublicPartnerType, reasonPartnerName?: string | null, reasonPartnerUuid?: string | null, canBeDeleted: boolean }> };

export type DeletePublicPartnerMutationVariables = Exact<{
  partnerId: Scalars['String'];
}>;


export type DeletePublicPartnerMutation = { __typename?: 'Mutation', deletePublicPartner: boolean };

export type PowerBiReportPageFragmentFragment = { __typename?: 'PowerBIReportPage', reportId: string, reportName: string, groupId: string, pageName: string, displayName: string, order: number };

export type GetPowerBiReportPagesQueryVariables = Exact<{
  reportId: Scalars['String'];
  groupId: Scalars['String'];
}>;


export type GetPowerBiReportPagesQuery = { __typename?: 'Query', listPowerBIReportPages: Array<{ __typename?: 'PowerBIReportPage', reportId: string, reportName: string, groupId: string, pageName: string, displayName: string, order: number }> };

export type GetNewPartnerOnboardingChecklistQueryVariables = Exact<{
  partnerId?: InputMaybe<Scalars['String']>;
}>;


export type GetNewPartnerOnboardingChecklistQuery = { __typename?: 'Query', newPartnerOnboardingChecklist?: { __typename?: 'PublicPortalChecklist', id: string, name: string, description: string, items: Array<{ __typename?: 'PublicPortalChecklistItem', id: string, value: string, order: number, completed: boolean }> } | null };

export type UpdatePublicPortalChecklistItemMutationVariables = Exact<{
  partnerId?: InputMaybe<Scalars['String']>;
  checklistItemId: Scalars['String'];
  completed: Scalars['Boolean'];
}>;


export type UpdatePublicPortalChecklistItemMutation = { __typename?: 'Mutation', updatePublicPortalChecklistItem?: { __typename?: 'PublicPortalChecklist', id: string, name: string, description: string, items: Array<{ __typename?: 'PublicPortalChecklistItem', id: string, value: string, order: number, completed: boolean }> } | null };

export type PpDataTablesNoBackfillsAvailableQueryVariables = Exact<{
  publicPartnerId: Scalars['String'];
}>;


export type PpDataTablesNoBackfillsAvailableQuery = { __typename?: 'Query', listDataTables: Array<{ __typename?: 'PublicPartnerDataTable', id: string, reportStatus: PublicPartnerDataTableReportStatus, dataStatus?: PublicPartnerDataTableReportDataStatus | null, outputSchemaType: PublicSchemaReportSchemaType, outputTableName: string, tableLogs?: Array<{ __typename?: 'PublicPartnerDataTableLogs', id: string, writeSinkSlug: string, dataStatus: PublicPartnerDataTableReportWriteSinkStatus, lastIngestedOn?: string | null, lastFailedOn?: string | null, lastSucceededOn?: string | null, numberRowsCreated?: number | null, numberRowsUpdated?: number | null }> | null, publicSchema?: { __typename?: 'PublicSchemaReport', id: string, name: string, description: string, portalType: PublicSchemaReportPortalType, outputTableName: string, outputSchemaName: PublicSchemaReportSchemaType, allowsBackfill: boolean, updateFrequency: PublicSchemaReportUpdateFrequency, reasonAutomationHelpUrl?: string | null, periods: Array<{ __typename?: 'PublicSchemaReportPeriod', id: string, period: PublicSchemaReportCoveredPeriod, availableHistoryRange?: number | null, availableHistoryRangeUnit?: PublicSchemaReportPeriodAvailableHistoryUnit | null, allowsBackfill: boolean, updateFrequency?: PublicSchemaReportUpdateFrequency | null }> } | null }> };

export type PpDataTablesWithBackfillsAvailableQueryVariables = Exact<{
  publicPartnerId: Scalars['String'];
}>;


export type PpDataTablesWithBackfillsAvailableQuery = { __typename?: 'Query', listDataTables: Array<{ __typename?: 'PublicPartnerDataTable', id: string, reportStatus: PublicPartnerDataTableReportStatus, dataStatus?: PublicPartnerDataTableReportDataStatus | null, outputSchemaType: PublicSchemaReportSchemaType, outputTableName: string, tableLogs?: Array<{ __typename?: 'PublicPartnerDataTableLogs', id: string, writeSinkSlug: string, dataStatus: PublicPartnerDataTableReportWriteSinkStatus, lastIngestedOn?: string | null, lastFailedOn?: string | null, lastSucceededOn?: string | null, numberRowsCreated?: number | null, numberRowsUpdated?: number | null }> | null, publicSchema?: { __typename?: 'PublicSchemaReport', id: string, name: string, description: string, portalType: PublicSchemaReportPortalType, outputTableName: string, outputSchemaName: PublicSchemaReportSchemaType, allowsBackfill: boolean, updateFrequency: PublicSchemaReportUpdateFrequency, periods: Array<{ __typename?: 'PublicSchemaReportPeriod', id: string, period: PublicSchemaReportCoveredPeriod, availableHistoryRange?: number | null, availableHistoryRangeUnit?: PublicSchemaReportPeriodAvailableHistoryUnit | null, allowsBackfill: boolean, updateFrequency?: PublicSchemaReportUpdateFrequency | null }> } | null, backfillsAvailable: Array<{ __typename?: 'PublicPartnerDataTableBackfill', priceCurrency?: StripeCurrencyType | null, priceAmount?: number | null, backfillPeriods: Array<{ __typename?: 'PublicSchemaReportPeriod', id: string, period: PublicSchemaReportCoveredPeriod, availableHistoryRange?: number | null, availableHistoryRangeUnit?: PublicSchemaReportPeriodAvailableHistoryUnit | null, allowsBackfill: boolean, updateFrequency?: PublicSchemaReportUpdateFrequency | null }> }> }> };

export type PpBackfillPurchaseMutationVariables = Exact<{
  publicPartnerId: Scalars['String'];
  backfillsToBePurchased: Array<PublicPartnerDataTableBackfillInput> | PublicPartnerDataTableBackfillInput;
}>;


export type PpBackfillPurchaseMutation = { __typename?: 'Mutation', purchaseBackfills?: boolean | null };

export type GetPublicPartnerCredentialsQueryVariables = Exact<{
  publicPartnerId: Scalars['String'];
}>;


export type GetPublicPartnerCredentialsQuery = { __typename?: 'Query', publicPartnerCredentials: Array<{ __typename?: 'PublicPartnerCredentials', type: PublicPartnerCredentialsType, postgresql?: { __typename?: 'PublicPartnerCredentialsPostgreSQL', host: string, port: number, ssl?: boolean | null, database: string, userName: string, password: string } | null, snowflake?: { __typename?: 'PublicPartnerCredentialsSnowflake', message: string } | null }> };

export type PpManageYourDataNodesQueryVariables = Exact<{
  partnerId: Scalars['String'];
}>;


export type PpManageYourDataNodesQuery = { __typename?: 'Query', listNodesData: Array<{ __typename?: 'DataReportNode', pageTitle: string, node: string, nodeType: DataReportNodeType, urlPath?: string | null, hiddenInNavigationTree?: boolean | null, showPartnerSelectionDropdown: boolean, childrenNodes?: Array<{ __typename?: 'DataReportNode', pageTitle: string, node: string, nodeType: DataReportNodeType, urlPath?: string | null, hiddenInNavigationTree?: boolean | null, showPartnerSelectionDropdown: boolean, childrenNodes?: Array<{ __typename?: 'DataReportNode', pageTitle: string, node: string, nodeType: DataReportNodeType, urlPath?: string | null, hiddenInNavigationTree?: boolean | null, showPartnerSelectionDropdown: boolean, icon: { __typename?: 'DataReportNodeIcon', fontAwesomeClasses?: Array<string> | null, httpIcon?: string | null }, uploadFileDefinitions?: Array<{ __typename?: 'DataReportUploadFileDefinition', dataTypeName: string, tableName: string, outputTableName: string, hasDataUploaded?: boolean | null, lastUpdatedOn?: string | null, reportType: DataReportType, downloadInstructions: Array<string>, fields: Array<{ __typename?: 'DataReportUploadFileFieldDefinition', name: string, regex?: string | null, regexErrorMessage?: string | null, alternativeNames: Array<string> }>, uniqueFields: Array<{ __typename?: 'DataReportUploadFileUniqueFieldDefinition', fieldNames: Array<string> }> }> | null, bannerAlarmDefinition?: Array<{ __typename?: 'DataReportBannerAlarmDefinition', id: string, activatedOn?: string | null, activatedUntil?: string | null, canBeDiscarded: boolean, titleHtml?: string | null, detailsHtml?: string | null, nodeTypePath: Array<DataReportNodeType> }> | null, powerBIReportDefinition?: { __typename?: 'DataReportPowerBIReportDefinition', name: string, id: string, groupId: string } | null }> | null, icon: { __typename?: 'DataReportNodeIcon', fontAwesomeClasses?: Array<string> | null, httpIcon?: string | null }, uploadFileDefinitions?: Array<{ __typename?: 'DataReportUploadFileDefinition', dataTypeName: string, tableName: string, outputTableName: string, hasDataUploaded?: boolean | null, lastUpdatedOn?: string | null, reportType: DataReportType, downloadInstructions: Array<string>, fields: Array<{ __typename?: 'DataReportUploadFileFieldDefinition', name: string, regex?: string | null, regexErrorMessage?: string | null, alternativeNames: Array<string> }>, uniqueFields: Array<{ __typename?: 'DataReportUploadFileUniqueFieldDefinition', fieldNames: Array<string> }> }> | null, bannerAlarmDefinition?: Array<{ __typename?: 'DataReportBannerAlarmDefinition', id: string, activatedOn?: string | null, activatedUntil?: string | null, canBeDiscarded: boolean, titleHtml?: string | null, detailsHtml?: string | null, nodeTypePath: Array<DataReportNodeType> }> | null, powerBIReportDefinition?: { __typename?: 'DataReportPowerBIReportDefinition', name: string, id: string, groupId: string } | null }> | null, icon: { __typename?: 'DataReportNodeIcon', fontAwesomeClasses?: Array<string> | null, httpIcon?: string | null }, uploadFileDefinitions?: Array<{ __typename?: 'DataReportUploadFileDefinition', dataTypeName: string, tableName: string, outputTableName: string, hasDataUploaded?: boolean | null, lastUpdatedOn?: string | null, reportType: DataReportType, downloadInstructions: Array<string>, fields: Array<{ __typename?: 'DataReportUploadFileFieldDefinition', name: string, regex?: string | null, regexErrorMessage?: string | null, alternativeNames: Array<string> }>, uniqueFields: Array<{ __typename?: 'DataReportUploadFileUniqueFieldDefinition', fieldNames: Array<string> }> }> | null, bannerAlarmDefinition?: Array<{ __typename?: 'DataReportBannerAlarmDefinition', id: string, activatedOn?: string | null, activatedUntil?: string | null, canBeDiscarded: boolean, titleHtml?: string | null, detailsHtml?: string | null, nodeTypePath: Array<DataReportNodeType> }> | null, powerBIReportDefinition?: { __typename?: 'DataReportPowerBIReportDefinition', name: string, id: string, groupId: string } | null }> };

export type DataNodeFragment = { __typename?: 'DataReportNode', pageTitle: string, node: string, nodeType: DataReportNodeType, urlPath?: string | null, hiddenInNavigationTree?: boolean | null, showPartnerSelectionDropdown: boolean, icon: { __typename?: 'DataReportNodeIcon', fontAwesomeClasses?: Array<string> | null, httpIcon?: string | null }, uploadFileDefinitions?: Array<{ __typename?: 'DataReportUploadFileDefinition', dataTypeName: string, tableName: string, outputTableName: string, hasDataUploaded?: boolean | null, lastUpdatedOn?: string | null, reportType: DataReportType, downloadInstructions: Array<string>, fields: Array<{ __typename?: 'DataReportUploadFileFieldDefinition', name: string, regex?: string | null, regexErrorMessage?: string | null, alternativeNames: Array<string> }>, uniqueFields: Array<{ __typename?: 'DataReportUploadFileUniqueFieldDefinition', fieldNames: Array<string> }> }> | null, bannerAlarmDefinition?: Array<{ __typename?: 'DataReportBannerAlarmDefinition', id: string, activatedOn?: string | null, activatedUntil?: string | null, canBeDiscarded: boolean, titleHtml?: string | null, detailsHtml?: string | null, nodeTypePath: Array<DataReportNodeType> }> | null, powerBIReportDefinition?: { __typename?: 'DataReportPowerBIReportDefinition', name: string, id: string, groupId: string } | null };

export type PpDownloadCsvMutationVariables = Exact<{
  partnerId: Scalars['String'];
  reportType: DataReportType;
}>;


export type PpDownloadCsvMutation = { __typename?: 'Mutation', generateDownloadFileUrlData: { __typename?: 'GenerateFileUrlResponse', signedS3URL?: string | null } };

export type PpDownloadTemplateCsvMutationVariables = Exact<{
  partnerId: Scalars['String'];
  reportType: DataReportType;
}>;


export type PpDownloadTemplateCsvMutation = { __typename?: 'Mutation', generateDownloadTemplateFileUrlData: { __typename?: 'GenerateFileUrlResponse', signedS3URL?: string | null } };

export type PpUploadCsvMutationVariables = Exact<{
  partnerId: Scalars['String'];
  reportType: DataReportType;
}>;


export type PpUploadCsvMutation = { __typename?: 'Mutation', generateUploadFileUrlData: { __typename?: 'GenerateFileUrlResponse', signedS3URL?: string | null } };

export type PpAwaitForUploadedFileIngestionMutationVariables = Exact<{
  partnerId: Scalars['String'];
  reportType: DataReportType;
  silentOnSuccess: Scalars['Boolean'];
}>;


export type PpAwaitForUploadedFileIngestionMutation = { __typename?: 'Mutation', awaitForUploadedFileIngestion: { __typename?: 'DataReportAwaitForUploadedFileIngestionResult', dataTypeName: string, tableName: string, isSuccess: boolean } };

export type PpGetHelpUrlForTableMutationVariables = Exact<{
  schemaType: PublicSchemaReportSchemaType;
  tableName: Scalars['String'];
}>;


export type PpGetHelpUrlForTableMutation = { __typename?: 'Mutation', getHelpUrlPublicSchema: { __typename?: 'PublicSchemaGetHelp', url: string } };

export type PpGetPbiTokenMutationVariables = Exact<{
  reportId: Scalars['String'];
  groupId: Scalars['String'];
}>;


export type PpGetPbiTokenMutation = { __typename?: 'Mutation', generatePowerBIReportContext?: { __typename?: 'PowerBIReportContext', embedUrl: string, accessToken: string } | null };

export type PbiExportMutationVariables = Exact<{
  reportId: Scalars['String'];
  groupId: Scalars['String'];
  format: PowerBiReportExportFormat;
  bookmarkState?: InputMaybe<Scalars['String']>;
  pages?: InputMaybe<Array<PowerBiReportExportPageInput> | PowerBiReportExportPageInput>;
}>;


export type PbiExportMutation = { __typename?: 'Mutation', exportPowerBIReport?: { __typename?: 'PowerBIReportExport', exportId: string } | null };

export type PbiExportRefreshStatusMutationVariables = Exact<{
  reportId: Scalars['String'];
  groupId: Scalars['String'];
  format: PowerBiReportExportFormat;
  exportId: Scalars['String'];
}>;


export type PbiExportRefreshStatusMutation = { __typename?: 'Mutation', refreshPowerBIReportExportStatus?: { __typename?: 'PowerBIReportExportStatus', status: PowerBiReportExportStatusType, exportCompletionPercentage: number, downloadUrl?: string | null, reportName: string } | null };

export type GetMarketplacesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMarketplacesQuery = { __typename?: 'Query', marketplaceUrls: Array<{ __typename?: 'MarketplaceUrl', id: string, baseUrl: string, baseAdvertisingUrl?: string | null, marketplace: Marketplace, productType: MarketplaceUrlProductType }> };

export type MarketplaceFragment = { __typename?: 'MarketplaceUrl', id: string, baseUrl: string, baseAdvertisingUrl?: string | null, marketplace: Marketplace, productType: MarketplaceUrlProductType };

export const PlanSubscriptionFragmentDoc = gql`
    fragment PlanSubscription on StripePlanInformationSubscription {
  name
  renewOn
  renewAmount
  renewPeriodType
  renewAmountCurrency
}
    `;
export const PlanSeatFragmentDoc = gql`
    fragment PlanSeat on StripePlanInformationSeat {
  name
  brand {
    publicPartnerId
    name
  }
  brandDashboard {
    name
  }
  brandDashboardSeat {
    id
    isSoftCancelled
    isFreeSeat
    assignedToEmail
    assignedToPublicUser {
      id
      email
    }
  }
  renewOn
  renewAmount
  renewPeriodType
  renewAmountCurrency
}
    `;
export const PpPublicPartnerUserFragmentDoc = gql`
    fragment PPPublicPartnerUser on PublicPartnerUser {
  id
  email
  status
  canReadData
}
    `;
export const PublicUserBrandDashboardSeatFragmentFragmentDoc = gql`
    fragment PublicUserBrandDashboardSeatFragment on PublicUserBrandDashboardSeat {
  id
  isSoftCancelled
  isFreeSeat
  assignedToEmail
  assignedToPublicUser {
    id
    email
  }
}
    `;
export const PublicUserBrandDashboardFragmentFragmentDoc = gql`
    fragment PublicUserBrandDashboardFragment on PublicUserBrandDashboard {
  name
  isEnabled
  seats {
    ...PublicUserBrandDashboardSeatFragment
  }
}
    ${PublicUserBrandDashboardSeatFragmentFragmentDoc}`;
export const PublicUserBrandFragmentFragmentDoc = gql`
    fragment PublicUserBrandFragment on PublicUserBrand {
  id
  publicPartnerId
  name
  reasonPartnerUuid
  type
  country
  canReadData
  canViewDashboards
  canManageConnections
  canBuy
  isAdmin
  isBillingAdmin
  dashboards {
    ...PublicUserBrandDashboardFragment
  }
}
    ${PublicUserBrandDashboardFragmentFragmentDoc}`;
export const PublicUserFragmentFragmentDoc = gql`
    fragment PublicUserFragment on PublicUser {
  id
  email
  status
  brands {
    ...PublicUserBrandFragment
  }
}
    ${PublicUserBrandFragmentFragmentDoc}`;
export const PublicPartnerFragmentFragmentDoc = gql`
    fragment PublicPartnerFragment on PublicPartner {
  advertisingProfileId
  createdAt
  id
  isConnected
  connectedStatus
  marketplace
  name
  friendlyName
  type
  reasonPartnerName
  reasonPartnerUuid
  canBeDeleted
}
    `;
export const PowerBiReportPageFragmentFragmentDoc = gql`
    fragment PowerBiReportPageFragment on PowerBIReportPage {
  reportId
  reportName
  groupId
  pageName
  displayName
  order
}
    `;
export const DataNodeFragmentDoc = gql`
    fragment dataNode on DataReportNode {
  pageTitle
  node
  nodeType
  urlPath
  icon {
    fontAwesomeClasses
    httpIcon
  }
  hiddenInNavigationTree
  showPartnerSelectionDropdown
  uploadFileDefinitions {
    dataTypeName
    tableName
    outputTableName
    hasDataUploaded
    lastUpdatedOn
    reportType
    fields {
      name
      regex
      regexErrorMessage
      alternativeNames
    }
    uniqueFields {
      fieldNames
    }
    downloadInstructions
  }
  bannerAlarmDefinition {
    id
    activatedOn
    activatedUntil
    canBeDiscarded
    titleHtml
    detailsHtml
    nodeTypePath
  }
  powerBIReportDefinition {
    name
    id
    groupId
  }
}
    `;
export const MarketplaceFragmentDoc = gql`
    fragment Marketplace on MarketplaceUrl {
  id
  baseUrl
  baseAdvertisingUrl
  marketplace
  productType
}
    `;
export const StripeSetupIntentDocument = gql`
    mutation StripeSetupIntent($partnerId: String!) {
  setupIntentStripe(partnerId: $partnerId) {
    clientSecret
  }
}
    `;
export type StripeSetupIntentMutationFn = Apollo.MutationFunction<StripeSetupIntentMutation, StripeSetupIntentMutationVariables>;

/**
 * __useStripeSetupIntentMutation__
 *
 * To run a mutation, you first call `useStripeSetupIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripeSetupIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripeSetupIntentMutation, { data, loading, error }] = useStripeSetupIntentMutation({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *   },
 * });
 */
export function useStripeSetupIntentMutation(baseOptions?: Apollo.MutationHookOptions<StripeSetupIntentMutation, StripeSetupIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StripeSetupIntentMutation, StripeSetupIntentMutationVariables>(StripeSetupIntentDocument, options);
      }
export type StripeSetupIntentMutationHookResult = ReturnType<typeof useStripeSetupIntentMutation>;
export type StripeSetupIntentMutationResult = Apollo.MutationResult<StripeSetupIntentMutation>;
export type StripeSetupIntentMutationOptions = Apollo.BaseMutationOptions<StripeSetupIntentMutation, StripeSetupIntentMutationVariables>;
export const StripeGetPaymentMethodsDocument = gql`
    query StripeGetPaymentMethods($partnerId: String!) {
  getPaymentMethodsStripe(partnerId: $partnerId) {
    type
    paymentMethodId
    isDefault
    cardType
    cardLast4
    cardExpirationYear
    cardExpirationMonth
    bankName
    bankAccountType
    bankAccountLast4
    linkEmail
  }
}
    `;

/**
 * __useStripeGetPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useStripeGetPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeGetPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeGetPaymentMethodsQuery({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *   },
 * });
 */
export function useStripeGetPaymentMethodsQuery(baseOptions: Apollo.QueryHookOptions<StripeGetPaymentMethodsQuery, StripeGetPaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StripeGetPaymentMethodsQuery, StripeGetPaymentMethodsQueryVariables>(StripeGetPaymentMethodsDocument, options);
      }
export function useStripeGetPaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StripeGetPaymentMethodsQuery, StripeGetPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StripeGetPaymentMethodsQuery, StripeGetPaymentMethodsQueryVariables>(StripeGetPaymentMethodsDocument, options);
        }
export type StripeGetPaymentMethodsQueryHookResult = ReturnType<typeof useStripeGetPaymentMethodsQuery>;
export type StripeGetPaymentMethodsLazyQueryHookResult = ReturnType<typeof useStripeGetPaymentMethodsLazyQuery>;
export type StripeGetPaymentMethodsQueryResult = Apollo.QueryResult<StripeGetPaymentMethodsQuery, StripeGetPaymentMethodsQueryVariables>;
export const StripeAddPaymentMethodDocument = gql`
    mutation StripeAddPaymentMethod($partnerId: String!, $paymentMethodId: String!) {
  addPaymentMethodStripe(partnerId: $partnerId, paymentMethodId: $paymentMethodId)
}
    `;
export type StripeAddPaymentMethodMutationFn = Apollo.MutationFunction<StripeAddPaymentMethodMutation, StripeAddPaymentMethodMutationVariables>;

/**
 * __useStripeAddPaymentMethodMutation__
 *
 * To run a mutation, you first call `useStripeAddPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripeAddPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripeAddPaymentMethodMutation, { data, loading, error }] = useStripeAddPaymentMethodMutation({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useStripeAddPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<StripeAddPaymentMethodMutation, StripeAddPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StripeAddPaymentMethodMutation, StripeAddPaymentMethodMutationVariables>(StripeAddPaymentMethodDocument, options);
      }
export type StripeAddPaymentMethodMutationHookResult = ReturnType<typeof useStripeAddPaymentMethodMutation>;
export type StripeAddPaymentMethodMutationResult = Apollo.MutationResult<StripeAddPaymentMethodMutation>;
export type StripeAddPaymentMethodMutationOptions = Apollo.BaseMutationOptions<StripeAddPaymentMethodMutation, StripeAddPaymentMethodMutationVariables>;
export const StripeRemovePaymentMethodDocument = gql`
    mutation StripeRemovePaymentMethod($partnerId: String!, $paymentMethodId: String!) {
  removePaymentMethodStripe(
    partnerId: $partnerId
    paymentMethodId: $paymentMethodId
  )
}
    `;
export type StripeRemovePaymentMethodMutationFn = Apollo.MutationFunction<StripeRemovePaymentMethodMutation, StripeRemovePaymentMethodMutationVariables>;

/**
 * __useStripeRemovePaymentMethodMutation__
 *
 * To run a mutation, you first call `useStripeRemovePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripeRemovePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripeRemovePaymentMethodMutation, { data, loading, error }] = useStripeRemovePaymentMethodMutation({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useStripeRemovePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<StripeRemovePaymentMethodMutation, StripeRemovePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StripeRemovePaymentMethodMutation, StripeRemovePaymentMethodMutationVariables>(StripeRemovePaymentMethodDocument, options);
      }
export type StripeRemovePaymentMethodMutationHookResult = ReturnType<typeof useStripeRemovePaymentMethodMutation>;
export type StripeRemovePaymentMethodMutationResult = Apollo.MutationResult<StripeRemovePaymentMethodMutation>;
export type StripeRemovePaymentMethodMutationOptions = Apollo.BaseMutationOptions<StripeRemovePaymentMethodMutation, StripeRemovePaymentMethodMutationVariables>;
export const StripeRemoveAllPaymentMethodDocument = gql`
    mutation StripeRemoveAllPaymentMethod($partnerId: String!) {
  removeAllPaymentMethodsStripe(partnerId: $partnerId)
}
    `;
export type StripeRemoveAllPaymentMethodMutationFn = Apollo.MutationFunction<StripeRemoveAllPaymentMethodMutation, StripeRemoveAllPaymentMethodMutationVariables>;

/**
 * __useStripeRemoveAllPaymentMethodMutation__
 *
 * To run a mutation, you first call `useStripeRemoveAllPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripeRemoveAllPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripeRemoveAllPaymentMethodMutation, { data, loading, error }] = useStripeRemoveAllPaymentMethodMutation({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *   },
 * });
 */
export function useStripeRemoveAllPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<StripeRemoveAllPaymentMethodMutation, StripeRemoveAllPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StripeRemoveAllPaymentMethodMutation, StripeRemoveAllPaymentMethodMutationVariables>(StripeRemoveAllPaymentMethodDocument, options);
      }
export type StripeRemoveAllPaymentMethodMutationHookResult = ReturnType<typeof useStripeRemoveAllPaymentMethodMutation>;
export type StripeRemoveAllPaymentMethodMutationResult = Apollo.MutationResult<StripeRemoveAllPaymentMethodMutation>;
export type StripeRemoveAllPaymentMethodMutationOptions = Apollo.BaseMutationOptions<StripeRemoveAllPaymentMethodMutation, StripeRemoveAllPaymentMethodMutationVariables>;
export const StripeSetPaymentMethodAsDefaultDocument = gql`
    mutation StripeSetPaymentMethodAsDefault($partnerId: String!, $paymentMethodId: String!) {
  setPaymentMethodAsDefaultStripe(
    partnerId: $partnerId
    paymentMethodId: $paymentMethodId
  )
}
    `;
export type StripeSetPaymentMethodAsDefaultMutationFn = Apollo.MutationFunction<StripeSetPaymentMethodAsDefaultMutation, StripeSetPaymentMethodAsDefaultMutationVariables>;

/**
 * __useStripeSetPaymentMethodAsDefaultMutation__
 *
 * To run a mutation, you first call `useStripeSetPaymentMethodAsDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripeSetPaymentMethodAsDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripeSetPaymentMethodAsDefaultMutation, { data, loading, error }] = useStripeSetPaymentMethodAsDefaultMutation({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useStripeSetPaymentMethodAsDefaultMutation(baseOptions?: Apollo.MutationHookOptions<StripeSetPaymentMethodAsDefaultMutation, StripeSetPaymentMethodAsDefaultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StripeSetPaymentMethodAsDefaultMutation, StripeSetPaymentMethodAsDefaultMutationVariables>(StripeSetPaymentMethodAsDefaultDocument, options);
      }
export type StripeSetPaymentMethodAsDefaultMutationHookResult = ReturnType<typeof useStripeSetPaymentMethodAsDefaultMutation>;
export type StripeSetPaymentMethodAsDefaultMutationResult = Apollo.MutationResult<StripeSetPaymentMethodAsDefaultMutation>;
export type StripeSetPaymentMethodAsDefaultMutationOptions = Apollo.BaseMutationOptions<StripeSetPaymentMethodAsDefaultMutation, StripeSetPaymentMethodAsDefaultMutationVariables>;
export const StripePurchaseDocument = gql`
    mutation StripePurchase($partnerId: String!, $purchaseType: StripePurchaseType!, $paymentMethodId: String!) {
  purchaseStripe(
    partnerId: $partnerId
    purchaseType: $purchaseType
    paymentMethodId: $paymentMethodId
  ) {
    purchaseType
    amount
    currency
  }
}
    `;
export type StripePurchaseMutationFn = Apollo.MutationFunction<StripePurchaseMutation, StripePurchaseMutationVariables>;

/**
 * __useStripePurchaseMutation__
 *
 * To run a mutation, you first call `useStripePurchaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripePurchaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripePurchaseMutation, { data, loading, error }] = useStripePurchaseMutation({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      purchaseType: // value for 'purchaseType'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useStripePurchaseMutation(baseOptions?: Apollo.MutationHookOptions<StripePurchaseMutation, StripePurchaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StripePurchaseMutation, StripePurchaseMutationVariables>(StripePurchaseDocument, options);
      }
export type StripePurchaseMutationHookResult = ReturnType<typeof useStripePurchaseMutation>;
export type StripePurchaseMutationResult = Apollo.MutationResult<StripePurchaseMutation>;
export type StripePurchaseMutationOptions = Apollo.BaseMutationOptions<StripePurchaseMutation, StripePurchaseMutationVariables>;
export const StripeGetPlanInformationDocument = gql`
    query StripeGetPlanInformation($partnerId: String!) {
  getPlanInformationStripe(partnerId: $partnerId) {
    subscriptions {
      ...PlanSubscription
    }
    seats {
      ...PlanSeat
    }
    renewUsingPaymentMethodId
    renewUsingPaymentMethodType
    cardType
    cardLast4
    cardExpirationMonth
    cardExpirationYear
    bankAccountType
    bankAccountLast4
    bankName
  }
}
    ${PlanSubscriptionFragmentDoc}
${PlanSeatFragmentDoc}`;

/**
 * __useStripeGetPlanInformationQuery__
 *
 * To run a query within a React component, call `useStripeGetPlanInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeGetPlanInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeGetPlanInformationQuery({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *   },
 * });
 */
export function useStripeGetPlanInformationQuery(baseOptions: Apollo.QueryHookOptions<StripeGetPlanInformationQuery, StripeGetPlanInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StripeGetPlanInformationQuery, StripeGetPlanInformationQueryVariables>(StripeGetPlanInformationDocument, options);
      }
export function useStripeGetPlanInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StripeGetPlanInformationQuery, StripeGetPlanInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StripeGetPlanInformationQuery, StripeGetPlanInformationQueryVariables>(StripeGetPlanInformationDocument, options);
        }
export type StripeGetPlanInformationQueryHookResult = ReturnType<typeof useStripeGetPlanInformationQuery>;
export type StripeGetPlanInformationLazyQueryHookResult = ReturnType<typeof useStripeGetPlanInformationLazyQuery>;
export type StripeGetPlanInformationQueryResult = Apollo.QueryResult<StripeGetPlanInformationQuery, StripeGetPlanInformationQueryVariables>;
export const StripeCancelPlanDocument = gql`
    mutation StripeCancelPlan($partnerId: String!) {
  cancelPlanStripe(partnerId: $partnerId)
}
    `;
export type StripeCancelPlanMutationFn = Apollo.MutationFunction<StripeCancelPlanMutation, StripeCancelPlanMutationVariables>;

/**
 * __useStripeCancelPlanMutation__
 *
 * To run a mutation, you first call `useStripeCancelPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripeCancelPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripeCancelPlanMutation, { data, loading, error }] = useStripeCancelPlanMutation({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *   },
 * });
 */
export function useStripeCancelPlanMutation(baseOptions?: Apollo.MutationHookOptions<StripeCancelPlanMutation, StripeCancelPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StripeCancelPlanMutation, StripeCancelPlanMutationVariables>(StripeCancelPlanDocument, options);
      }
export type StripeCancelPlanMutationHookResult = ReturnType<typeof useStripeCancelPlanMutation>;
export type StripeCancelPlanMutationResult = Apollo.MutationResult<StripeCancelPlanMutation>;
export type StripeCancelPlanMutationOptions = Apollo.BaseMutationOptions<StripeCancelPlanMutation, StripeCancelPlanMutationVariables>;
export const StripeGetPublicPartnerDashboardDocument = gql`
    query StripeGetPublicPartnerDashboard($partnerId: String!, $name: String!) {
  publicPartnerDashboard(partnerId: $partnerId, name: $name) {
    name
    isEnabled
    seats {
      id
      isSoftCancelled
      isFreeSeat
      assignedToEmail
      assignedToPublicUser {
        id
        email
      }
    }
  }
}
    `;

/**
 * __useStripeGetPublicPartnerDashboardQuery__
 *
 * To run a query within a React component, call `useStripeGetPublicPartnerDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeGetPublicPartnerDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeGetPublicPartnerDashboardQuery({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useStripeGetPublicPartnerDashboardQuery(baseOptions: Apollo.QueryHookOptions<StripeGetPublicPartnerDashboardQuery, StripeGetPublicPartnerDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StripeGetPublicPartnerDashboardQuery, StripeGetPublicPartnerDashboardQueryVariables>(StripeGetPublicPartnerDashboardDocument, options);
      }
export function useStripeGetPublicPartnerDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StripeGetPublicPartnerDashboardQuery, StripeGetPublicPartnerDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StripeGetPublicPartnerDashboardQuery, StripeGetPublicPartnerDashboardQueryVariables>(StripeGetPublicPartnerDashboardDocument, options);
        }
export type StripeGetPublicPartnerDashboardQueryHookResult = ReturnType<typeof useStripeGetPublicPartnerDashboardQuery>;
export type StripeGetPublicPartnerDashboardLazyQueryHookResult = ReturnType<typeof useStripeGetPublicPartnerDashboardLazyQuery>;
export type StripeGetPublicPartnerDashboardQueryResult = Apollo.QueryResult<StripeGetPublicPartnerDashboardQuery, StripeGetPublicPartnerDashboardQueryVariables>;
export const PpGetPublicPartnerUsersDocument = gql`
    query PPGetPublicPartnerUsers($partnerId: String!) {
  publicPartner(partnerId: $partnerId) {
    users {
      ...PPPublicPartnerUser
    }
  }
}
    ${PpPublicPartnerUserFragmentDoc}`;

/**
 * __usePpGetPublicPartnerUsersQuery__
 *
 * To run a query within a React component, call `usePpGetPublicPartnerUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePpGetPublicPartnerUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePpGetPublicPartnerUsersQuery({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *   },
 * });
 */
export function usePpGetPublicPartnerUsersQuery(baseOptions: Apollo.QueryHookOptions<PpGetPublicPartnerUsersQuery, PpGetPublicPartnerUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PpGetPublicPartnerUsersQuery, PpGetPublicPartnerUsersQueryVariables>(PpGetPublicPartnerUsersDocument, options);
      }
export function usePpGetPublicPartnerUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PpGetPublicPartnerUsersQuery, PpGetPublicPartnerUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PpGetPublicPartnerUsersQuery, PpGetPublicPartnerUsersQueryVariables>(PpGetPublicPartnerUsersDocument, options);
        }
export type PpGetPublicPartnerUsersQueryHookResult = ReturnType<typeof usePpGetPublicPartnerUsersQuery>;
export type PpGetPublicPartnerUsersLazyQueryHookResult = ReturnType<typeof usePpGetPublicPartnerUsersLazyQuery>;
export type PpGetPublicPartnerUsersQueryResult = Apollo.QueryResult<PpGetPublicPartnerUsersQuery, PpGetPublicPartnerUsersQueryVariables>;
export const StripeGetBillingInformationDocument = gql`
    query StripeGetBillingInformation($partnerId: String!) {
  getBillingInformationStripe(partnerId: $partnerId) {
    name
    phoneNumber
    addressLine1
    addressLine2
    city
    postalCode
    state
    countryCode
  }
}
    `;

/**
 * __useStripeGetBillingInformationQuery__
 *
 * To run a query within a React component, call `useStripeGetBillingInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeGetBillingInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeGetBillingInformationQuery({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *   },
 * });
 */
export function useStripeGetBillingInformationQuery(baseOptions: Apollo.QueryHookOptions<StripeGetBillingInformationQuery, StripeGetBillingInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StripeGetBillingInformationQuery, StripeGetBillingInformationQueryVariables>(StripeGetBillingInformationDocument, options);
      }
export function useStripeGetBillingInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StripeGetBillingInformationQuery, StripeGetBillingInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StripeGetBillingInformationQuery, StripeGetBillingInformationQueryVariables>(StripeGetBillingInformationDocument, options);
        }
export type StripeGetBillingInformationQueryHookResult = ReturnType<typeof useStripeGetBillingInformationQuery>;
export type StripeGetBillingInformationLazyQueryHookResult = ReturnType<typeof useStripeGetBillingInformationLazyQuery>;
export type StripeGetBillingInformationQueryResult = Apollo.QueryResult<StripeGetBillingInformationQuery, StripeGetBillingInformationQueryVariables>;
export const StripeSetBillingInformationDocument = gql`
    mutation StripeSetBillingInformation($partnerId: String!, $name: String!, $phoneNumber: String, $addressLine1: String, $addressLine2: String, $city: String, $postalCode: String, $state: String, $countryCode: String) {
  setBillingInformationStripe(
    partnerId: $partnerId
    billingInformation: {name: $name, phoneNumber: $phoneNumber, addressLine1: $addressLine1, addressLine2: $addressLine2, city: $city, postalCode: $postalCode, state: $state, countryCode: $countryCode}
  )
}
    `;
export type StripeSetBillingInformationMutationFn = Apollo.MutationFunction<StripeSetBillingInformationMutation, StripeSetBillingInformationMutationVariables>;

/**
 * __useStripeSetBillingInformationMutation__
 *
 * To run a mutation, you first call `useStripeSetBillingInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripeSetBillingInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripeSetBillingInformationMutation, { data, loading, error }] = useStripeSetBillingInformationMutation({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      name: // value for 'name'
 *      phoneNumber: // value for 'phoneNumber'
 *      addressLine1: // value for 'addressLine1'
 *      addressLine2: // value for 'addressLine2'
 *      city: // value for 'city'
 *      postalCode: // value for 'postalCode'
 *      state: // value for 'state'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useStripeSetBillingInformationMutation(baseOptions?: Apollo.MutationHookOptions<StripeSetBillingInformationMutation, StripeSetBillingInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StripeSetBillingInformationMutation, StripeSetBillingInformationMutationVariables>(StripeSetBillingInformationDocument, options);
      }
export type StripeSetBillingInformationMutationHookResult = ReturnType<typeof useStripeSetBillingInformationMutation>;
export type StripeSetBillingInformationMutationResult = Apollo.MutationResult<StripeSetBillingInformationMutation>;
export type StripeSetBillingInformationMutationOptions = Apollo.BaseMutationOptions<StripeSetBillingInformationMutation, StripeSetBillingInformationMutationVariables>;
export const StripeGetInvoiceHistoryDocument = gql`
    query StripeGetInvoiceHistory($partnerId: String!) {
  getInvoiceHistoryStripe(partnerId: $partnerId) {
    id
    invoiceNumber
    receiptNumber
    dueDate
    periodStart
    periodEnd
    invoicePdf
    status
    currency
    amount
    amountPaid
    accountName
    customerName
    paymentMethodId
    receiptUrl
    cardType
    cardLast4
    cardExpirationMonth
    cardExpirationYear
    bankAccountType
    bankAccountLast4
    bankName
  }
}
    `;

/**
 * __useStripeGetInvoiceHistoryQuery__
 *
 * To run a query within a React component, call `useStripeGetInvoiceHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeGetInvoiceHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeGetInvoiceHistoryQuery({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *   },
 * });
 */
export function useStripeGetInvoiceHistoryQuery(baseOptions: Apollo.QueryHookOptions<StripeGetInvoiceHistoryQuery, StripeGetInvoiceHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StripeGetInvoiceHistoryQuery, StripeGetInvoiceHistoryQueryVariables>(StripeGetInvoiceHistoryDocument, options);
      }
export function useStripeGetInvoiceHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StripeGetInvoiceHistoryQuery, StripeGetInvoiceHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StripeGetInvoiceHistoryQuery, StripeGetInvoiceHistoryQueryVariables>(StripeGetInvoiceHistoryDocument, options);
        }
export type StripeGetInvoiceHistoryQueryHookResult = ReturnType<typeof useStripeGetInvoiceHistoryQuery>;
export type StripeGetInvoiceHistoryLazyQueryHookResult = ReturnType<typeof useStripeGetInvoiceHistoryLazyQuery>;
export type StripeGetInvoiceHistoryQueryResult = Apollo.QueryResult<StripeGetInvoiceHistoryQuery, StripeGetInvoiceHistoryQueryVariables>;
export const UserManagementPublicUsersDocument = gql`
    query UserManagementPublicUsers {
  listPublicUsers {
    ...PublicUserFragment
  }
}
    ${PublicUserFragmentFragmentDoc}`;

/**
 * __useUserManagementPublicUsersQuery__
 *
 * To run a query within a React component, call `useUserManagementPublicUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserManagementPublicUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserManagementPublicUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserManagementPublicUsersQuery(baseOptions?: Apollo.QueryHookOptions<UserManagementPublicUsersQuery, UserManagementPublicUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserManagementPublicUsersQuery, UserManagementPublicUsersQueryVariables>(UserManagementPublicUsersDocument, options);
      }
export function useUserManagementPublicUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserManagementPublicUsersQuery, UserManagementPublicUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserManagementPublicUsersQuery, UserManagementPublicUsersQueryVariables>(UserManagementPublicUsersDocument, options);
        }
export type UserManagementPublicUsersQueryHookResult = ReturnType<typeof useUserManagementPublicUsersQuery>;
export type UserManagementPublicUsersLazyQueryHookResult = ReturnType<typeof useUserManagementPublicUsersLazyQuery>;
export type UserManagementPublicUsersQueryResult = Apollo.QueryResult<UserManagementPublicUsersQuery, UserManagementPublicUsersQueryVariables>;
export const UserManagementGetPublicUserDocument = gql`
    query UserManagementGetPublicUser($id: String!) {
  getPublicUser(id: $id) {
    ...PublicUserFragment
  }
}
    ${PublicUserFragmentFragmentDoc}`;

/**
 * __useUserManagementGetPublicUserQuery__
 *
 * To run a query within a React component, call `useUserManagementGetPublicUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserManagementGetPublicUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserManagementGetPublicUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserManagementGetPublicUserQuery(baseOptions: Apollo.QueryHookOptions<UserManagementGetPublicUserQuery, UserManagementGetPublicUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserManagementGetPublicUserQuery, UserManagementGetPublicUserQueryVariables>(UserManagementGetPublicUserDocument, options);
      }
export function useUserManagementGetPublicUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserManagementGetPublicUserQuery, UserManagementGetPublicUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserManagementGetPublicUserQuery, UserManagementGetPublicUserQueryVariables>(UserManagementGetPublicUserDocument, options);
        }
export type UserManagementGetPublicUserQueryHookResult = ReturnType<typeof useUserManagementGetPublicUserQuery>;
export type UserManagementGetPublicUserLazyQueryHookResult = ReturnType<typeof useUserManagementGetPublicUserLazyQuery>;
export type UserManagementGetPublicUserQueryResult = Apollo.QueryResult<UserManagementGetPublicUserQuery, UserManagementGetPublicUserQueryVariables>;
export const UserManagementAddPublicUserDocument = gql`
    mutation UserManagementAddPublicUser($name: String!, $email: String!, $brands: [AddPublicUserBrandInput!]!) {
  addPublicUser(name: $name, email: $email, brands: $brands)
}
    `;
export type UserManagementAddPublicUserMutationFn = Apollo.MutationFunction<UserManagementAddPublicUserMutation, UserManagementAddPublicUserMutationVariables>;

/**
 * __useUserManagementAddPublicUserMutation__
 *
 * To run a mutation, you first call `useUserManagementAddPublicUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserManagementAddPublicUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userManagementAddPublicUserMutation, { data, loading, error }] = useUserManagementAddPublicUserMutation({
 *   variables: {
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      brands: // value for 'brands'
 *   },
 * });
 */
export function useUserManagementAddPublicUserMutation(baseOptions?: Apollo.MutationHookOptions<UserManagementAddPublicUserMutation, UserManagementAddPublicUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserManagementAddPublicUserMutation, UserManagementAddPublicUserMutationVariables>(UserManagementAddPublicUserDocument, options);
      }
export type UserManagementAddPublicUserMutationHookResult = ReturnType<typeof useUserManagementAddPublicUserMutation>;
export type UserManagementAddPublicUserMutationResult = Apollo.MutationResult<UserManagementAddPublicUserMutation>;
export type UserManagementAddPublicUserMutationOptions = Apollo.BaseMutationOptions<UserManagementAddPublicUserMutation, UserManagementAddPublicUserMutationVariables>;
export const UserManagementRemovePublicUserDocument = gql`
    mutation UserManagementRemovePublicUser($id: String!) {
  removePublicUser(id: $id)
}
    `;
export type UserManagementRemovePublicUserMutationFn = Apollo.MutationFunction<UserManagementRemovePublicUserMutation, UserManagementRemovePublicUserMutationVariables>;

/**
 * __useUserManagementRemovePublicUserMutation__
 *
 * To run a mutation, you first call `useUserManagementRemovePublicUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserManagementRemovePublicUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userManagementRemovePublicUserMutation, { data, loading, error }] = useUserManagementRemovePublicUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserManagementRemovePublicUserMutation(baseOptions?: Apollo.MutationHookOptions<UserManagementRemovePublicUserMutation, UserManagementRemovePublicUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserManagementRemovePublicUserMutation, UserManagementRemovePublicUserMutationVariables>(UserManagementRemovePublicUserDocument, options);
      }
export type UserManagementRemovePublicUserMutationHookResult = ReturnType<typeof useUserManagementRemovePublicUserMutation>;
export type UserManagementRemovePublicUserMutationResult = Apollo.MutationResult<UserManagementRemovePublicUserMutation>;
export type UserManagementRemovePublicUserMutationOptions = Apollo.BaseMutationOptions<UserManagementRemovePublicUserMutation, UserManagementRemovePublicUserMutationVariables>;
export const UserManagementReinvitePublicUserDocument = gql`
    mutation UserManagementReinvitePublicUser($id: String!) {
  reinvitePublicUser(id: $id)
}
    `;
export type UserManagementReinvitePublicUserMutationFn = Apollo.MutationFunction<UserManagementReinvitePublicUserMutation, UserManagementReinvitePublicUserMutationVariables>;

/**
 * __useUserManagementReinvitePublicUserMutation__
 *
 * To run a mutation, you first call `useUserManagementReinvitePublicUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserManagementReinvitePublicUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userManagementReinvitePublicUserMutation, { data, loading, error }] = useUserManagementReinvitePublicUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserManagementReinvitePublicUserMutation(baseOptions?: Apollo.MutationHookOptions<UserManagementReinvitePublicUserMutation, UserManagementReinvitePublicUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserManagementReinvitePublicUserMutation, UserManagementReinvitePublicUserMutationVariables>(UserManagementReinvitePublicUserDocument, options);
      }
export type UserManagementReinvitePublicUserMutationHookResult = ReturnType<typeof useUserManagementReinvitePublicUserMutation>;
export type UserManagementReinvitePublicUserMutationResult = Apollo.MutationResult<UserManagementReinvitePublicUserMutation>;
export type UserManagementReinvitePublicUserMutationOptions = Apollo.BaseMutationOptions<UserManagementReinvitePublicUserMutation, UserManagementReinvitePublicUserMutationVariables>;
export const UserManagementSetBrandPermissionsPublicUserDocument = gql`
    mutation UserManagementSetBrandPermissionsPublicUser($userId: String!, $brandId: String!, $isAdmin: Boolean!, $isBillingAdmin: Boolean!, $canBuy: Boolean!, $canManageConnections: Boolean!, $canViewDashboards: Boolean!, $canReadData: Boolean!) {
  setBrandPermissionsPublicUser(
    userId: $userId
    brandId: $brandId
    isAdmin: $isAdmin
    isBillingAdmin: $isBillingAdmin
    canBuy: $canBuy
    canManageConnections: $canManageConnections
    canViewDashboards: $canViewDashboards
    canReadData: $canReadData
  )
}
    `;
export type UserManagementSetBrandPermissionsPublicUserMutationFn = Apollo.MutationFunction<UserManagementSetBrandPermissionsPublicUserMutation, UserManagementSetBrandPermissionsPublicUserMutationVariables>;

/**
 * __useUserManagementSetBrandPermissionsPublicUserMutation__
 *
 * To run a mutation, you first call `useUserManagementSetBrandPermissionsPublicUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserManagementSetBrandPermissionsPublicUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userManagementSetBrandPermissionsPublicUserMutation, { data, loading, error }] = useUserManagementSetBrandPermissionsPublicUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      brandId: // value for 'brandId'
 *      isAdmin: // value for 'isAdmin'
 *      isBillingAdmin: // value for 'isBillingAdmin'
 *      canBuy: // value for 'canBuy'
 *      canManageConnections: // value for 'canManageConnections'
 *      canViewDashboards: // value for 'canViewDashboards'
 *      canReadData: // value for 'canReadData'
 *   },
 * });
 */
export function useUserManagementSetBrandPermissionsPublicUserMutation(baseOptions?: Apollo.MutationHookOptions<UserManagementSetBrandPermissionsPublicUserMutation, UserManagementSetBrandPermissionsPublicUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserManagementSetBrandPermissionsPublicUserMutation, UserManagementSetBrandPermissionsPublicUserMutationVariables>(UserManagementSetBrandPermissionsPublicUserDocument, options);
      }
export type UserManagementSetBrandPermissionsPublicUserMutationHookResult = ReturnType<typeof useUserManagementSetBrandPermissionsPublicUserMutation>;
export type UserManagementSetBrandPermissionsPublicUserMutationResult = Apollo.MutationResult<UserManagementSetBrandPermissionsPublicUserMutation>;
export type UserManagementSetBrandPermissionsPublicUserMutationOptions = Apollo.BaseMutationOptions<UserManagementSetBrandPermissionsPublicUserMutation, UserManagementSetBrandPermissionsPublicUserMutationVariables>;
export const UserManagementAssignBrandDashboardSeatPublicUserDocument = gql`
    mutation UserManagementAssignBrandDashboardSeatPublicUser($userId: String!, $brandId: String!, $dashboardName: String!) {
  assignBrandDashboardSeatPublicUser(
    userId: $userId
    brandId: $brandId
    dashboardName: $dashboardName
  )
}
    `;
export type UserManagementAssignBrandDashboardSeatPublicUserMutationFn = Apollo.MutationFunction<UserManagementAssignBrandDashboardSeatPublicUserMutation, UserManagementAssignBrandDashboardSeatPublicUserMutationVariables>;

/**
 * __useUserManagementAssignBrandDashboardSeatPublicUserMutation__
 *
 * To run a mutation, you first call `useUserManagementAssignBrandDashboardSeatPublicUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserManagementAssignBrandDashboardSeatPublicUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userManagementAssignBrandDashboardSeatPublicUserMutation, { data, loading, error }] = useUserManagementAssignBrandDashboardSeatPublicUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      brandId: // value for 'brandId'
 *      dashboardName: // value for 'dashboardName'
 *   },
 * });
 */
export function useUserManagementAssignBrandDashboardSeatPublicUserMutation(baseOptions?: Apollo.MutationHookOptions<UserManagementAssignBrandDashboardSeatPublicUserMutation, UserManagementAssignBrandDashboardSeatPublicUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserManagementAssignBrandDashboardSeatPublicUserMutation, UserManagementAssignBrandDashboardSeatPublicUserMutationVariables>(UserManagementAssignBrandDashboardSeatPublicUserDocument, options);
      }
export type UserManagementAssignBrandDashboardSeatPublicUserMutationHookResult = ReturnType<typeof useUserManagementAssignBrandDashboardSeatPublicUserMutation>;
export type UserManagementAssignBrandDashboardSeatPublicUserMutationResult = Apollo.MutationResult<UserManagementAssignBrandDashboardSeatPublicUserMutation>;
export type UserManagementAssignBrandDashboardSeatPublicUserMutationOptions = Apollo.BaseMutationOptions<UserManagementAssignBrandDashboardSeatPublicUserMutation, UserManagementAssignBrandDashboardSeatPublicUserMutationVariables>;
export const UserManagementUnassignBrandDashboardSeatPublicUserDocument = gql`
    mutation UserManagementUnassignBrandDashboardSeatPublicUser($userId: String!, $brandId: String!, $dashboardName: String!) {
  unassignBrandDashboardSeatPublicUser(
    userId: $userId
    brandId: $brandId
    dashboardName: $dashboardName
  )
}
    `;
export type UserManagementUnassignBrandDashboardSeatPublicUserMutationFn = Apollo.MutationFunction<UserManagementUnassignBrandDashboardSeatPublicUserMutation, UserManagementUnassignBrandDashboardSeatPublicUserMutationVariables>;

/**
 * __useUserManagementUnassignBrandDashboardSeatPublicUserMutation__
 *
 * To run a mutation, you first call `useUserManagementUnassignBrandDashboardSeatPublicUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserManagementUnassignBrandDashboardSeatPublicUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userManagementUnassignBrandDashboardSeatPublicUserMutation, { data, loading, error }] = useUserManagementUnassignBrandDashboardSeatPublicUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      brandId: // value for 'brandId'
 *      dashboardName: // value for 'dashboardName'
 *   },
 * });
 */
export function useUserManagementUnassignBrandDashboardSeatPublicUserMutation(baseOptions?: Apollo.MutationHookOptions<UserManagementUnassignBrandDashboardSeatPublicUserMutation, UserManagementUnassignBrandDashboardSeatPublicUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserManagementUnassignBrandDashboardSeatPublicUserMutation, UserManagementUnassignBrandDashboardSeatPublicUserMutationVariables>(UserManagementUnassignBrandDashboardSeatPublicUserDocument, options);
      }
export type UserManagementUnassignBrandDashboardSeatPublicUserMutationHookResult = ReturnType<typeof useUserManagementUnassignBrandDashboardSeatPublicUserMutation>;
export type UserManagementUnassignBrandDashboardSeatPublicUserMutationResult = Apollo.MutationResult<UserManagementUnassignBrandDashboardSeatPublicUserMutation>;
export type UserManagementUnassignBrandDashboardSeatPublicUserMutationOptions = Apollo.BaseMutationOptions<UserManagementUnassignBrandDashboardSeatPublicUserMutation, UserManagementUnassignBrandDashboardSeatPublicUserMutationVariables>;
export const UserManagementPurchaseBrandDashboardSeatPublicUserDocument = gql`
    mutation UserManagementPurchaseBrandDashboardSeatPublicUser($brandId: String!, $dashboardName: String!, $evalOnly: Boolean!) {
  purchaseBrandDashboardSeatPublicUser(
    brandId: $brandId
    dashboardName: $dashboardName
    evalOnly: $evalOnly
  ) {
    id
    error
    errorType
    renewAmount
    renewPeriodType
    renewAmountCurrency
  }
}
    `;
export type UserManagementPurchaseBrandDashboardSeatPublicUserMutationFn = Apollo.MutationFunction<UserManagementPurchaseBrandDashboardSeatPublicUserMutation, UserManagementPurchaseBrandDashboardSeatPublicUserMutationVariables>;

/**
 * __useUserManagementPurchaseBrandDashboardSeatPublicUserMutation__
 *
 * To run a mutation, you first call `useUserManagementPurchaseBrandDashboardSeatPublicUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserManagementPurchaseBrandDashboardSeatPublicUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userManagementPurchaseBrandDashboardSeatPublicUserMutation, { data, loading, error }] = useUserManagementPurchaseBrandDashboardSeatPublicUserMutation({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      dashboardName: // value for 'dashboardName'
 *      evalOnly: // value for 'evalOnly'
 *   },
 * });
 */
export function useUserManagementPurchaseBrandDashboardSeatPublicUserMutation(baseOptions?: Apollo.MutationHookOptions<UserManagementPurchaseBrandDashboardSeatPublicUserMutation, UserManagementPurchaseBrandDashboardSeatPublicUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserManagementPurchaseBrandDashboardSeatPublicUserMutation, UserManagementPurchaseBrandDashboardSeatPublicUserMutationVariables>(UserManagementPurchaseBrandDashboardSeatPublicUserDocument, options);
      }
export type UserManagementPurchaseBrandDashboardSeatPublicUserMutationHookResult = ReturnType<typeof useUserManagementPurchaseBrandDashboardSeatPublicUserMutation>;
export type UserManagementPurchaseBrandDashboardSeatPublicUserMutationResult = Apollo.MutationResult<UserManagementPurchaseBrandDashboardSeatPublicUserMutation>;
export type UserManagementPurchaseBrandDashboardSeatPublicUserMutationOptions = Apollo.BaseMutationOptions<UserManagementPurchaseBrandDashboardSeatPublicUserMutation, UserManagementPurchaseBrandDashboardSeatPublicUserMutationVariables>;
export const UserManagementCancelBrandDashboardSeatPublicUserDocument = gql`
    mutation UserManagementCancelBrandDashboardSeatPublicUser($brandId: String!, $dashboardName: String!, $id: String!, $evalOnly: Boolean!) {
  cancelBrandDashboardSeatPublicUser(
    brandId: $brandId
    dashboardName: $dashboardName
    id: $id
    evalOnly: $evalOnly
  ) {
    id
    renewAmount
    renewPeriodType
    renewAmountCurrency
    cancelOn
    didCancel
  }
}
    `;
export type UserManagementCancelBrandDashboardSeatPublicUserMutationFn = Apollo.MutationFunction<UserManagementCancelBrandDashboardSeatPublicUserMutation, UserManagementCancelBrandDashboardSeatPublicUserMutationVariables>;

/**
 * __useUserManagementCancelBrandDashboardSeatPublicUserMutation__
 *
 * To run a mutation, you first call `useUserManagementCancelBrandDashboardSeatPublicUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserManagementCancelBrandDashboardSeatPublicUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userManagementCancelBrandDashboardSeatPublicUserMutation, { data, loading, error }] = useUserManagementCancelBrandDashboardSeatPublicUserMutation({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      dashboardName: // value for 'dashboardName'
 *      id: // value for 'id'
 *      evalOnly: // value for 'evalOnly'
 *   },
 * });
 */
export function useUserManagementCancelBrandDashboardSeatPublicUserMutation(baseOptions?: Apollo.MutationHookOptions<UserManagementCancelBrandDashboardSeatPublicUserMutation, UserManagementCancelBrandDashboardSeatPublicUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserManagementCancelBrandDashboardSeatPublicUserMutation, UserManagementCancelBrandDashboardSeatPublicUserMutationVariables>(UserManagementCancelBrandDashboardSeatPublicUserDocument, options);
      }
export type UserManagementCancelBrandDashboardSeatPublicUserMutationHookResult = ReturnType<typeof useUserManagementCancelBrandDashboardSeatPublicUserMutation>;
export type UserManagementCancelBrandDashboardSeatPublicUserMutationResult = Apollo.MutationResult<UserManagementCancelBrandDashboardSeatPublicUserMutation>;
export type UserManagementCancelBrandDashboardSeatPublicUserMutationOptions = Apollo.BaseMutationOptions<UserManagementCancelBrandDashboardSeatPublicUserMutation, UserManagementCancelBrandDashboardSeatPublicUserMutationVariables>;
export const GetLwaClientIdDocument = gql`
    query GetLWAClientId {
  clientIds {
    advertisingClientId
    sellerVendorClientId
  }
}
    `;

/**
 * __useGetLwaClientIdQuery__
 *
 * To run a query within a React component, call `useGetLwaClientIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLwaClientIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLwaClientIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLwaClientIdQuery(baseOptions?: Apollo.QueryHookOptions<GetLwaClientIdQuery, GetLwaClientIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLwaClientIdQuery, GetLwaClientIdQueryVariables>(GetLwaClientIdDocument, options);
      }
export function useGetLwaClientIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLwaClientIdQuery, GetLwaClientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLwaClientIdQuery, GetLwaClientIdQueryVariables>(GetLwaClientIdDocument, options);
        }
export type GetLwaClientIdQueryHookResult = ReturnType<typeof useGetLwaClientIdQuery>;
export type GetLwaClientIdLazyQueryHookResult = ReturnType<typeof useGetLwaClientIdLazyQuery>;
export type GetLwaClientIdQueryResult = Apollo.QueryResult<GetLwaClientIdQuery, GetLwaClientIdQueryVariables>;
export const PpListBackfillsDocument = gql`
    query pp_listBackfills($publicPartnerId: String!) {
  listBackfills(publicPartnerId: $publicPartnerId) {
    id
    status
    percentageCompletion
    startedAt
    lastUpdatedOn
    requesterEmail
    requestedBy
    reports {
      id
      reportName
      description
      outputTableName
      outputSchemaType
      publicSchema {
        reasonAutomationHelpUrl
      }
      requestedPeriods {
        id
        period
        backfillStartDate
        backfillEndDate
      }
    }
  }
}
    `;

/**
 * __usePpListBackfillsQuery__
 *
 * To run a query within a React component, call `usePpListBackfillsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePpListBackfillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePpListBackfillsQuery({
 *   variables: {
 *      publicPartnerId: // value for 'publicPartnerId'
 *   },
 * });
 */
export function usePpListBackfillsQuery(baseOptions: Apollo.QueryHookOptions<PpListBackfillsQuery, PpListBackfillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PpListBackfillsQuery, PpListBackfillsQueryVariables>(PpListBackfillsDocument, options);
      }
export function usePpListBackfillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PpListBackfillsQuery, PpListBackfillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PpListBackfillsQuery, PpListBackfillsQueryVariables>(PpListBackfillsDocument, options);
        }
export type PpListBackfillsQueryHookResult = ReturnType<typeof usePpListBackfillsQuery>;
export type PpListBackfillsLazyQueryHookResult = ReturnType<typeof usePpListBackfillsLazyQuery>;
export type PpListBackfillsQueryResult = Apollo.QueryResult<PpListBackfillsQuery, PpListBackfillsQueryVariables>;
export const RecognizePublicPartnerDocument = gql`
    mutation RecognizePublicPartner($code: String!, $redirectUri: String!, $marketplace: String!, $accountType: PublicPartnerType!, $sellingPartnerId: String, $adsProfileId: String) {
  recognizePublicPartner(
    code: $code
    redirectUri: $redirectUri
    marketPlace: $marketplace
    accountType: $accountType
    sellingPartnerId: $sellingPartnerId
    adsProfileId: $adsProfileId
  ) {
    accountId
    entityId
    accountName
    marketPlaces
    sellerItems {
      asin
      asinUri
      sku
      name
      brand
    }
    vendorOrders {
      asin
      asinUri
      orderDate
      orderNumber
    }
    campaigns {
      spCampaigns
      sbCampaigns
      sdCampaigns
    }
    token
  }
}
    `;
export type RecognizePublicPartnerMutationFn = Apollo.MutationFunction<RecognizePublicPartnerMutation, RecognizePublicPartnerMutationVariables>;

/**
 * __useRecognizePublicPartnerMutation__
 *
 * To run a mutation, you first call `useRecognizePublicPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecognizePublicPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recognizePublicPartnerMutation, { data, loading, error }] = useRecognizePublicPartnerMutation({
 *   variables: {
 *      code: // value for 'code'
 *      redirectUri: // value for 'redirectUri'
 *      marketplace: // value for 'marketplace'
 *      accountType: // value for 'accountType'
 *      sellingPartnerId: // value for 'sellingPartnerId'
 *      adsProfileId: // value for 'adsProfileId'
 *   },
 * });
 */
export function useRecognizePublicPartnerMutation(baseOptions?: Apollo.MutationHookOptions<RecognizePublicPartnerMutation, RecognizePublicPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecognizePublicPartnerMutation, RecognizePublicPartnerMutationVariables>(RecognizePublicPartnerDocument, options);
      }
export type RecognizePublicPartnerMutationHookResult = ReturnType<typeof useRecognizePublicPartnerMutation>;
export type RecognizePublicPartnerMutationResult = Apollo.MutationResult<RecognizePublicPartnerMutation>;
export type RecognizePublicPartnerMutationOptions = Apollo.BaseMutationOptions<RecognizePublicPartnerMutation, RecognizePublicPartnerMutationVariables>;
export const SelectAdvertisingProfileDocument = gql`
    mutation SelectAdvertisingProfile($partnerId: String!, $advertisingProfileId: String!) {
  selectAdvertisingProfile(
    advertisingProfileId: $advertisingProfileId
    partnerId: $partnerId
  )
}
    `;
export type SelectAdvertisingProfileMutationFn = Apollo.MutationFunction<SelectAdvertisingProfileMutation, SelectAdvertisingProfileMutationVariables>;

/**
 * __useSelectAdvertisingProfileMutation__
 *
 * To run a mutation, you first call `useSelectAdvertisingProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectAdvertisingProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectAdvertisingProfileMutation, { data, loading, error }] = useSelectAdvertisingProfileMutation({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      advertisingProfileId: // value for 'advertisingProfileId'
 *   },
 * });
 */
export function useSelectAdvertisingProfileMutation(baseOptions?: Apollo.MutationHookOptions<SelectAdvertisingProfileMutation, SelectAdvertisingProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelectAdvertisingProfileMutation, SelectAdvertisingProfileMutationVariables>(SelectAdvertisingProfileDocument, options);
      }
export type SelectAdvertisingProfileMutationHookResult = ReturnType<typeof useSelectAdvertisingProfileMutation>;
export type SelectAdvertisingProfileMutationResult = Apollo.MutationResult<SelectAdvertisingProfileMutation>;
export type SelectAdvertisingProfileMutationOptions = Apollo.BaseMutationOptions<SelectAdvertisingProfileMutation, SelectAdvertisingProfileMutationVariables>;
export const GetAdvertisingProfilesDocument = gql`
    query GetAdvertisingProfiles($partnerId: String!) {
  getAdvertisingProfiles(partnerId: $partnerId) {
    id
    name
    type
    countryCode
  }
}
    `;

/**
 * __useGetAdvertisingProfilesQuery__
 *
 * To run a query within a React component, call `useGetAdvertisingProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvertisingProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvertisingProfilesQuery({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *   },
 * });
 */
export function useGetAdvertisingProfilesQuery(baseOptions: Apollo.QueryHookOptions<GetAdvertisingProfilesQuery, GetAdvertisingProfilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdvertisingProfilesQuery, GetAdvertisingProfilesQueryVariables>(GetAdvertisingProfilesDocument, options);
      }
export function useGetAdvertisingProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdvertisingProfilesQuery, GetAdvertisingProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdvertisingProfilesQuery, GetAdvertisingProfilesQueryVariables>(GetAdvertisingProfilesDocument, options);
        }
export type GetAdvertisingProfilesQueryHookResult = ReturnType<typeof useGetAdvertisingProfilesQuery>;
export type GetAdvertisingProfilesLazyQueryHookResult = ReturnType<typeof useGetAdvertisingProfilesLazyQuery>;
export type GetAdvertisingProfilesQueryResult = Apollo.QueryResult<GetAdvertisingProfilesQuery, GetAdvertisingProfilesQueryVariables>;
export const CreatePartnerDocument = gql`
    mutation CreatePartner($partner: PublicPartnerInput!) {
  createPublicPartner(partner: $partner) {
    ...PublicPartnerFragment
  }
}
    ${PublicPartnerFragmentFragmentDoc}`;
export type CreatePartnerMutationFn = Apollo.MutationFunction<CreatePartnerMutation, CreatePartnerMutationVariables>;

/**
 * __useCreatePartnerMutation__
 *
 * To run a mutation, you first call `useCreatePartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPartnerMutation, { data, loading, error }] = useCreatePartnerMutation({
 *   variables: {
 *      partner: // value for 'partner'
 *   },
 * });
 */
export function useCreatePartnerMutation(baseOptions?: Apollo.MutationHookOptions<CreatePartnerMutation, CreatePartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePartnerMutation, CreatePartnerMutationVariables>(CreatePartnerDocument, options);
      }
export type CreatePartnerMutationHookResult = ReturnType<typeof useCreatePartnerMutation>;
export type CreatePartnerMutationResult = Apollo.MutationResult<CreatePartnerMutation>;
export type CreatePartnerMutationOptions = Apollo.BaseMutationOptions<CreatePartnerMutation, CreatePartnerMutationVariables>;
export const UpdatePartnerDocument = gql`
    mutation UpdatePartner($partnerId: String!, $name: String, $friendlyName: String) {
  updatePublicPartner(
    partnerId: $partnerId
    name: $name
    friendlyName: $friendlyName
  ) {
    ...PublicPartnerFragment
  }
}
    ${PublicPartnerFragmentFragmentDoc}`;
export type UpdatePartnerMutationFn = Apollo.MutationFunction<UpdatePartnerMutation, UpdatePartnerMutationVariables>;

/**
 * __useUpdatePartnerMutation__
 *
 * To run a mutation, you first call `useUpdatePartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartnerMutation, { data, loading, error }] = useUpdatePartnerMutation({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      name: // value for 'name'
 *      friendlyName: // value for 'friendlyName'
 *   },
 * });
 */
export function useUpdatePartnerMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePartnerMutation, UpdatePartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePartnerMutation, UpdatePartnerMutationVariables>(UpdatePartnerDocument, options);
      }
export type UpdatePartnerMutationHookResult = ReturnType<typeof useUpdatePartnerMutation>;
export type UpdatePartnerMutationResult = Apollo.MutationResult<UpdatePartnerMutation>;
export type UpdatePartnerMutationOptions = Apollo.BaseMutationOptions<UpdatePartnerMutation, UpdatePartnerMutationVariables>;
export const PpGenerateSystemReportForPpPartnerDocument = gql`
    mutation pp_generateSystemReportForPPPartner($partnerId: String!) {
  generateSystemReports(publicPartnerId: $partnerId)
}
    `;
export type PpGenerateSystemReportForPpPartnerMutationFn = Apollo.MutationFunction<PpGenerateSystemReportForPpPartnerMutation, PpGenerateSystemReportForPpPartnerMutationVariables>;

/**
 * __usePpGenerateSystemReportForPpPartnerMutation__
 *
 * To run a mutation, you first call `usePpGenerateSystemReportForPpPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePpGenerateSystemReportForPpPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ppGenerateSystemReportForPpPartnerMutation, { data, loading, error }] = usePpGenerateSystemReportForPpPartnerMutation({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *   },
 * });
 */
export function usePpGenerateSystemReportForPpPartnerMutation(baseOptions?: Apollo.MutationHookOptions<PpGenerateSystemReportForPpPartnerMutation, PpGenerateSystemReportForPpPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PpGenerateSystemReportForPpPartnerMutation, PpGenerateSystemReportForPpPartnerMutationVariables>(PpGenerateSystemReportForPpPartnerDocument, options);
      }
export type PpGenerateSystemReportForPpPartnerMutationHookResult = ReturnType<typeof usePpGenerateSystemReportForPpPartnerMutation>;
export type PpGenerateSystemReportForPpPartnerMutationResult = Apollo.MutationResult<PpGenerateSystemReportForPpPartnerMutation>;
export type PpGenerateSystemReportForPpPartnerMutationOptions = Apollo.BaseMutationOptions<PpGenerateSystemReportForPpPartnerMutation, PpGenerateSystemReportForPpPartnerMutationVariables>;
export const ConnectPartnerMutationDocument = gql`
    mutation ConnectPartnerMutation($code: String!, $partnerId: String!, $redirectUri: String!, $sellingPartnerId: String!, $refreshToken: String) {
  connectPublicPartner(
    code: $code
    partnerId: $partnerId
    redirectUri: $redirectUri
    sellingPartnerId: $sellingPartnerId
    refreshToken: $refreshToken
  )
}
    `;
export type ConnectPartnerMutationMutationFn = Apollo.MutationFunction<ConnectPartnerMutationMutation, ConnectPartnerMutationMutationVariables>;

/**
 * __useConnectPartnerMutationMutation__
 *
 * To run a mutation, you first call `useConnectPartnerMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectPartnerMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectPartnerMutationMutation, { data, loading, error }] = useConnectPartnerMutationMutation({
 *   variables: {
 *      code: // value for 'code'
 *      partnerId: // value for 'partnerId'
 *      redirectUri: // value for 'redirectUri'
 *      sellingPartnerId: // value for 'sellingPartnerId'
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useConnectPartnerMutationMutation(baseOptions?: Apollo.MutationHookOptions<ConnectPartnerMutationMutation, ConnectPartnerMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectPartnerMutationMutation, ConnectPartnerMutationMutationVariables>(ConnectPartnerMutationDocument, options);
      }
export type ConnectPartnerMutationMutationHookResult = ReturnType<typeof useConnectPartnerMutationMutation>;
export type ConnectPartnerMutationMutationResult = Apollo.MutationResult<ConnectPartnerMutationMutation>;
export type ConnectPartnerMutationMutationOptions = Apollo.BaseMutationOptions<ConnectPartnerMutationMutation, ConnectPartnerMutationMutationVariables>;
export const ConnectAdvertisingDocument = gql`
    mutation ConnectAdvertising($partnerId: String!, $code: String!, $redirectUri: String!) {
  connectAdvertisingPublicPartner(
    code: $code
    partnerId: $partnerId
    redirectUri: $redirectUri
  )
}
    `;
export type ConnectAdvertisingMutationFn = Apollo.MutationFunction<ConnectAdvertisingMutation, ConnectAdvertisingMutationVariables>;

/**
 * __useConnectAdvertisingMutation__
 *
 * To run a mutation, you first call `useConnectAdvertisingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectAdvertisingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectAdvertisingMutation, { data, loading, error }] = useConnectAdvertisingMutation({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      code: // value for 'code'
 *      redirectUri: // value for 'redirectUri'
 *   },
 * });
 */
export function useConnectAdvertisingMutation(baseOptions?: Apollo.MutationHookOptions<ConnectAdvertisingMutation, ConnectAdvertisingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectAdvertisingMutation, ConnectAdvertisingMutationVariables>(ConnectAdvertisingDocument, options);
      }
export type ConnectAdvertisingMutationHookResult = ReturnType<typeof useConnectAdvertisingMutation>;
export type ConnectAdvertisingMutationResult = Apollo.MutationResult<ConnectAdvertisingMutation>;
export type ConnectAdvertisingMutationOptions = Apollo.BaseMutationOptions<ConnectAdvertisingMutation, ConnectAdvertisingMutationVariables>;
export const PublicPartnersDocument = gql`
    query PublicPartners {
  publicPartners {
    ...PublicPartnerFragment
  }
}
    ${PublicPartnerFragmentFragmentDoc}`;

/**
 * __usePublicPartnersQuery__
 *
 * To run a query within a React component, call `usePublicPartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicPartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicPartnersQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicPartnersQuery(baseOptions?: Apollo.QueryHookOptions<PublicPartnersQuery, PublicPartnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicPartnersQuery, PublicPartnersQueryVariables>(PublicPartnersDocument, options);
      }
export function usePublicPartnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicPartnersQuery, PublicPartnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicPartnersQuery, PublicPartnersQueryVariables>(PublicPartnersDocument, options);
        }
export type PublicPartnersQueryHookResult = ReturnType<typeof usePublicPartnersQuery>;
export type PublicPartnersLazyQueryHookResult = ReturnType<typeof usePublicPartnersLazyQuery>;
export type PublicPartnersQueryResult = Apollo.QueryResult<PublicPartnersQuery, PublicPartnersQueryVariables>;
export const DeletePublicPartnerDocument = gql`
    mutation DeletePublicPartner($partnerId: String!) {
  deletePublicPartner(partnerId: $partnerId)
}
    `;
export type DeletePublicPartnerMutationFn = Apollo.MutationFunction<DeletePublicPartnerMutation, DeletePublicPartnerMutationVariables>;

/**
 * __useDeletePublicPartnerMutation__
 *
 * To run a mutation, you first call `useDeletePublicPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePublicPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePublicPartnerMutation, { data, loading, error }] = useDeletePublicPartnerMutation({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *   },
 * });
 */
export function useDeletePublicPartnerMutation(baseOptions?: Apollo.MutationHookOptions<DeletePublicPartnerMutation, DeletePublicPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePublicPartnerMutation, DeletePublicPartnerMutationVariables>(DeletePublicPartnerDocument, options);
      }
export type DeletePublicPartnerMutationHookResult = ReturnType<typeof useDeletePublicPartnerMutation>;
export type DeletePublicPartnerMutationResult = Apollo.MutationResult<DeletePublicPartnerMutation>;
export type DeletePublicPartnerMutationOptions = Apollo.BaseMutationOptions<DeletePublicPartnerMutation, DeletePublicPartnerMutationVariables>;
export const GetPowerBiReportPagesDocument = gql`
    query GetPowerBIReportPages($reportId: String!, $groupId: String!) {
  listPowerBIReportPages(reportId: $reportId, groupId: $groupId) {
    ...PowerBiReportPageFragment
  }
}
    ${PowerBiReportPageFragmentFragmentDoc}`;

/**
 * __useGetPowerBiReportPagesQuery__
 *
 * To run a query within a React component, call `useGetPowerBiReportPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPowerBiReportPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPowerBiReportPagesQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetPowerBiReportPagesQuery(baseOptions: Apollo.QueryHookOptions<GetPowerBiReportPagesQuery, GetPowerBiReportPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPowerBiReportPagesQuery, GetPowerBiReportPagesQueryVariables>(GetPowerBiReportPagesDocument, options);
      }
export function useGetPowerBiReportPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPowerBiReportPagesQuery, GetPowerBiReportPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPowerBiReportPagesQuery, GetPowerBiReportPagesQueryVariables>(GetPowerBiReportPagesDocument, options);
        }
export type GetPowerBiReportPagesQueryHookResult = ReturnType<typeof useGetPowerBiReportPagesQuery>;
export type GetPowerBiReportPagesLazyQueryHookResult = ReturnType<typeof useGetPowerBiReportPagesLazyQuery>;
export type GetPowerBiReportPagesQueryResult = Apollo.QueryResult<GetPowerBiReportPagesQuery, GetPowerBiReportPagesQueryVariables>;
export const GetNewPartnerOnboardingChecklistDocument = gql`
    query GetNewPartnerOnboardingChecklist($partnerId: String) {
  newPartnerOnboardingChecklist(partnerId: $partnerId) {
    id
    name
    description
    items {
      id
      value
      order
      completed
    }
  }
}
    `;

/**
 * __useGetNewPartnerOnboardingChecklistQuery__
 *
 * To run a query within a React component, call `useGetNewPartnerOnboardingChecklistQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewPartnerOnboardingChecklistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewPartnerOnboardingChecklistQuery({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *   },
 * });
 */
export function useGetNewPartnerOnboardingChecklistQuery(baseOptions?: Apollo.QueryHookOptions<GetNewPartnerOnboardingChecklistQuery, GetNewPartnerOnboardingChecklistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewPartnerOnboardingChecklistQuery, GetNewPartnerOnboardingChecklistQueryVariables>(GetNewPartnerOnboardingChecklistDocument, options);
      }
export function useGetNewPartnerOnboardingChecklistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewPartnerOnboardingChecklistQuery, GetNewPartnerOnboardingChecklistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewPartnerOnboardingChecklistQuery, GetNewPartnerOnboardingChecklistQueryVariables>(GetNewPartnerOnboardingChecklistDocument, options);
        }
export type GetNewPartnerOnboardingChecklistQueryHookResult = ReturnType<typeof useGetNewPartnerOnboardingChecklistQuery>;
export type GetNewPartnerOnboardingChecklistLazyQueryHookResult = ReturnType<typeof useGetNewPartnerOnboardingChecklistLazyQuery>;
export type GetNewPartnerOnboardingChecklistQueryResult = Apollo.QueryResult<GetNewPartnerOnboardingChecklistQuery, GetNewPartnerOnboardingChecklistQueryVariables>;
export const UpdatePublicPortalChecklistItemDocument = gql`
    mutation UpdatePublicPortalChecklistItem($partnerId: String, $checklistItemId: String!, $completed: Boolean!) {
  updatePublicPortalChecklistItem(
    partnerId: $partnerId
    checklistItemId: $checklistItemId
    completed: $completed
  ) {
    id
    name
    description
    items {
      id
      value
      order
      completed
    }
  }
}
    `;
export type UpdatePublicPortalChecklistItemMutationFn = Apollo.MutationFunction<UpdatePublicPortalChecklistItemMutation, UpdatePublicPortalChecklistItemMutationVariables>;

/**
 * __useUpdatePublicPortalChecklistItemMutation__
 *
 * To run a mutation, you first call `useUpdatePublicPortalChecklistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePublicPortalChecklistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePublicPortalChecklistItemMutation, { data, loading, error }] = useUpdatePublicPortalChecklistItemMutation({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      checklistItemId: // value for 'checklistItemId'
 *      completed: // value for 'completed'
 *   },
 * });
 */
export function useUpdatePublicPortalChecklistItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePublicPortalChecklistItemMutation, UpdatePublicPortalChecklistItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePublicPortalChecklistItemMutation, UpdatePublicPortalChecklistItemMutationVariables>(UpdatePublicPortalChecklistItemDocument, options);
      }
export type UpdatePublicPortalChecklistItemMutationHookResult = ReturnType<typeof useUpdatePublicPortalChecklistItemMutation>;
export type UpdatePublicPortalChecklistItemMutationResult = Apollo.MutationResult<UpdatePublicPortalChecklistItemMutation>;
export type UpdatePublicPortalChecklistItemMutationOptions = Apollo.BaseMutationOptions<UpdatePublicPortalChecklistItemMutation, UpdatePublicPortalChecklistItemMutationVariables>;
export const PpDataTablesNoBackfillsAvailableDocument = gql`
    query pp_dataTables_noBackfillsAvailable($publicPartnerId: String!) {
  listDataTables(publicPartnerId: $publicPartnerId) {
    id
    reportStatus
    dataStatus
    outputSchemaType
    outputTableName
    tableLogs {
      id
      writeSinkSlug
      dataStatus
      lastIngestedOn
      lastFailedOn
      lastSucceededOn
      numberRowsCreated
      numberRowsUpdated
    }
    publicSchema {
      id
      name
      description
      portalType
      outputTableName
      outputSchemaName
      allowsBackfill
      updateFrequency
      reasonAutomationHelpUrl
      periods {
        id
        period
        availableHistoryRange
        availableHistoryRangeUnit
        allowsBackfill
        updateFrequency
      }
    }
    tableLogs {
      id
      writeSinkSlug
      dataStatus
      lastIngestedOn
      lastFailedOn
      lastSucceededOn
      numberRowsCreated
      numberRowsUpdated
    }
  }
}
    `;

/**
 * __usePpDataTablesNoBackfillsAvailableQuery__
 *
 * To run a query within a React component, call `usePpDataTablesNoBackfillsAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `usePpDataTablesNoBackfillsAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePpDataTablesNoBackfillsAvailableQuery({
 *   variables: {
 *      publicPartnerId: // value for 'publicPartnerId'
 *   },
 * });
 */
export function usePpDataTablesNoBackfillsAvailableQuery(baseOptions: Apollo.QueryHookOptions<PpDataTablesNoBackfillsAvailableQuery, PpDataTablesNoBackfillsAvailableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PpDataTablesNoBackfillsAvailableQuery, PpDataTablesNoBackfillsAvailableQueryVariables>(PpDataTablesNoBackfillsAvailableDocument, options);
      }
export function usePpDataTablesNoBackfillsAvailableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PpDataTablesNoBackfillsAvailableQuery, PpDataTablesNoBackfillsAvailableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PpDataTablesNoBackfillsAvailableQuery, PpDataTablesNoBackfillsAvailableQueryVariables>(PpDataTablesNoBackfillsAvailableDocument, options);
        }
export type PpDataTablesNoBackfillsAvailableQueryHookResult = ReturnType<typeof usePpDataTablesNoBackfillsAvailableQuery>;
export type PpDataTablesNoBackfillsAvailableLazyQueryHookResult = ReturnType<typeof usePpDataTablesNoBackfillsAvailableLazyQuery>;
export type PpDataTablesNoBackfillsAvailableQueryResult = Apollo.QueryResult<PpDataTablesNoBackfillsAvailableQuery, PpDataTablesNoBackfillsAvailableQueryVariables>;
export const PpDataTablesWithBackfillsAvailableDocument = gql`
    query pp_dataTables_withBackfillsAvailable($publicPartnerId: String!) {
  listDataTables(publicPartnerId: $publicPartnerId) {
    id
    reportStatus
    dataStatus
    outputSchemaType
    outputTableName
    tableLogs {
      id
      writeSinkSlug
      dataStatus
      lastIngestedOn
      lastFailedOn
      lastSucceededOn
      numberRowsCreated
      numberRowsUpdated
    }
    publicSchema {
      id
      name
      description
      portalType
      outputTableName
      outputSchemaName
      allowsBackfill
      updateFrequency
      periods {
        id
        period
        availableHistoryRange
        availableHistoryRangeUnit
        allowsBackfill
        updateFrequency
      }
    }
    backfillsAvailable {
      backfillPeriods {
        id
        period
        availableHistoryRange
        availableHistoryRangeUnit
        allowsBackfill
        updateFrequency
      }
      priceCurrency
      priceAmount
    }
  }
}
    `;

/**
 * __usePpDataTablesWithBackfillsAvailableQuery__
 *
 * To run a query within a React component, call `usePpDataTablesWithBackfillsAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `usePpDataTablesWithBackfillsAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePpDataTablesWithBackfillsAvailableQuery({
 *   variables: {
 *      publicPartnerId: // value for 'publicPartnerId'
 *   },
 * });
 */
export function usePpDataTablesWithBackfillsAvailableQuery(baseOptions: Apollo.QueryHookOptions<PpDataTablesWithBackfillsAvailableQuery, PpDataTablesWithBackfillsAvailableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PpDataTablesWithBackfillsAvailableQuery, PpDataTablesWithBackfillsAvailableQueryVariables>(PpDataTablesWithBackfillsAvailableDocument, options);
      }
export function usePpDataTablesWithBackfillsAvailableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PpDataTablesWithBackfillsAvailableQuery, PpDataTablesWithBackfillsAvailableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PpDataTablesWithBackfillsAvailableQuery, PpDataTablesWithBackfillsAvailableQueryVariables>(PpDataTablesWithBackfillsAvailableDocument, options);
        }
export type PpDataTablesWithBackfillsAvailableQueryHookResult = ReturnType<typeof usePpDataTablesWithBackfillsAvailableQuery>;
export type PpDataTablesWithBackfillsAvailableLazyQueryHookResult = ReturnType<typeof usePpDataTablesWithBackfillsAvailableLazyQuery>;
export type PpDataTablesWithBackfillsAvailableQueryResult = Apollo.QueryResult<PpDataTablesWithBackfillsAvailableQuery, PpDataTablesWithBackfillsAvailableQueryVariables>;
export const PpBackfillPurchaseDocument = gql`
    mutation pp_backfill_purchase($publicPartnerId: String!, $backfillsToBePurchased: [PublicPartnerDataTableBackfillInput!]!) {
  purchaseBackfills(
    publicPartnerId: $publicPartnerId
    backfillsToBePurchased: $backfillsToBePurchased
  )
}
    `;
export type PpBackfillPurchaseMutationFn = Apollo.MutationFunction<PpBackfillPurchaseMutation, PpBackfillPurchaseMutationVariables>;

/**
 * __usePpBackfillPurchaseMutation__
 *
 * To run a mutation, you first call `usePpBackfillPurchaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePpBackfillPurchaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ppBackfillPurchaseMutation, { data, loading, error }] = usePpBackfillPurchaseMutation({
 *   variables: {
 *      publicPartnerId: // value for 'publicPartnerId'
 *      backfillsToBePurchased: // value for 'backfillsToBePurchased'
 *   },
 * });
 */
export function usePpBackfillPurchaseMutation(baseOptions?: Apollo.MutationHookOptions<PpBackfillPurchaseMutation, PpBackfillPurchaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PpBackfillPurchaseMutation, PpBackfillPurchaseMutationVariables>(PpBackfillPurchaseDocument, options);
      }
export type PpBackfillPurchaseMutationHookResult = ReturnType<typeof usePpBackfillPurchaseMutation>;
export type PpBackfillPurchaseMutationResult = Apollo.MutationResult<PpBackfillPurchaseMutation>;
export type PpBackfillPurchaseMutationOptions = Apollo.BaseMutationOptions<PpBackfillPurchaseMutation, PpBackfillPurchaseMutationVariables>;
export const GetPublicPartnerCredentialsDocument = gql`
    query GetPublicPartnerCredentials($publicPartnerId: String!) {
  publicPartnerCredentials(partnerId: $publicPartnerId) {
    type
    postgresql {
      host
      port
      ssl
      database
      userName
      password
    }
    snowflake {
      message
    }
  }
}
    `;

/**
 * __useGetPublicPartnerCredentialsQuery__
 *
 * To run a query within a React component, call `useGetPublicPartnerCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicPartnerCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicPartnerCredentialsQuery({
 *   variables: {
 *      publicPartnerId: // value for 'publicPartnerId'
 *   },
 * });
 */
export function useGetPublicPartnerCredentialsQuery(baseOptions: Apollo.QueryHookOptions<GetPublicPartnerCredentialsQuery, GetPublicPartnerCredentialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicPartnerCredentialsQuery, GetPublicPartnerCredentialsQueryVariables>(GetPublicPartnerCredentialsDocument, options);
      }
export function useGetPublicPartnerCredentialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicPartnerCredentialsQuery, GetPublicPartnerCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicPartnerCredentialsQuery, GetPublicPartnerCredentialsQueryVariables>(GetPublicPartnerCredentialsDocument, options);
        }
export type GetPublicPartnerCredentialsQueryHookResult = ReturnType<typeof useGetPublicPartnerCredentialsQuery>;
export type GetPublicPartnerCredentialsLazyQueryHookResult = ReturnType<typeof useGetPublicPartnerCredentialsLazyQuery>;
export type GetPublicPartnerCredentialsQueryResult = Apollo.QueryResult<GetPublicPartnerCredentialsQuery, GetPublicPartnerCredentialsQueryVariables>;
export const PpManageYourDataNodesDocument = gql`
    query pp_manageYourDataNodes($partnerId: String!) {
  listNodesData(partnerId: $partnerId) {
    ...dataNode
    childrenNodes {
      ...dataNode
      childrenNodes {
        ...dataNode
      }
    }
  }
}
    ${DataNodeFragmentDoc}`;

/**
 * __usePpManageYourDataNodesQuery__
 *
 * To run a query within a React component, call `usePpManageYourDataNodesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePpManageYourDataNodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePpManageYourDataNodesQuery({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *   },
 * });
 */
export function usePpManageYourDataNodesQuery(baseOptions: Apollo.QueryHookOptions<PpManageYourDataNodesQuery, PpManageYourDataNodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PpManageYourDataNodesQuery, PpManageYourDataNodesQueryVariables>(PpManageYourDataNodesDocument, options);
      }
export function usePpManageYourDataNodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PpManageYourDataNodesQuery, PpManageYourDataNodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PpManageYourDataNodesQuery, PpManageYourDataNodesQueryVariables>(PpManageYourDataNodesDocument, options);
        }
export type PpManageYourDataNodesQueryHookResult = ReturnType<typeof usePpManageYourDataNodesQuery>;
export type PpManageYourDataNodesLazyQueryHookResult = ReturnType<typeof usePpManageYourDataNodesLazyQuery>;
export type PpManageYourDataNodesQueryResult = Apollo.QueryResult<PpManageYourDataNodesQuery, PpManageYourDataNodesQueryVariables>;
export const PpDownloadCsvDocument = gql`
    mutation pp_download_csv($partnerId: String!, $reportType: DataReportType!) {
  generateDownloadFileUrlData(partnerId: $partnerId, reportType: $reportType) {
    signedS3URL
  }
}
    `;
export type PpDownloadCsvMutationFn = Apollo.MutationFunction<PpDownloadCsvMutation, PpDownloadCsvMutationVariables>;

/**
 * __usePpDownloadCsvMutation__
 *
 * To run a mutation, you first call `usePpDownloadCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePpDownloadCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ppDownloadCsvMutation, { data, loading, error }] = usePpDownloadCsvMutation({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      reportType: // value for 'reportType'
 *   },
 * });
 */
export function usePpDownloadCsvMutation(baseOptions?: Apollo.MutationHookOptions<PpDownloadCsvMutation, PpDownloadCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PpDownloadCsvMutation, PpDownloadCsvMutationVariables>(PpDownloadCsvDocument, options);
      }
export type PpDownloadCsvMutationHookResult = ReturnType<typeof usePpDownloadCsvMutation>;
export type PpDownloadCsvMutationResult = Apollo.MutationResult<PpDownloadCsvMutation>;
export type PpDownloadCsvMutationOptions = Apollo.BaseMutationOptions<PpDownloadCsvMutation, PpDownloadCsvMutationVariables>;
export const PpDownloadTemplateCsvDocument = gql`
    mutation pp_download_template_csv($partnerId: String!, $reportType: DataReportType!) {
  generateDownloadTemplateFileUrlData(
    partnerId: $partnerId
    reportType: $reportType
  ) {
    signedS3URL
  }
}
    `;
export type PpDownloadTemplateCsvMutationFn = Apollo.MutationFunction<PpDownloadTemplateCsvMutation, PpDownloadTemplateCsvMutationVariables>;

/**
 * __usePpDownloadTemplateCsvMutation__
 *
 * To run a mutation, you first call `usePpDownloadTemplateCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePpDownloadTemplateCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ppDownloadTemplateCsvMutation, { data, loading, error }] = usePpDownloadTemplateCsvMutation({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      reportType: // value for 'reportType'
 *   },
 * });
 */
export function usePpDownloadTemplateCsvMutation(baseOptions?: Apollo.MutationHookOptions<PpDownloadTemplateCsvMutation, PpDownloadTemplateCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PpDownloadTemplateCsvMutation, PpDownloadTemplateCsvMutationVariables>(PpDownloadTemplateCsvDocument, options);
      }
export type PpDownloadTemplateCsvMutationHookResult = ReturnType<typeof usePpDownloadTemplateCsvMutation>;
export type PpDownloadTemplateCsvMutationResult = Apollo.MutationResult<PpDownloadTemplateCsvMutation>;
export type PpDownloadTemplateCsvMutationOptions = Apollo.BaseMutationOptions<PpDownloadTemplateCsvMutation, PpDownloadTemplateCsvMutationVariables>;
export const PpUploadCsvDocument = gql`
    mutation pp_upload_csv($partnerId: String!, $reportType: DataReportType!) {
  generateUploadFileUrlData(partnerId: $partnerId, reportType: $reportType) {
    signedS3URL
  }
}
    `;
export type PpUploadCsvMutationFn = Apollo.MutationFunction<PpUploadCsvMutation, PpUploadCsvMutationVariables>;

/**
 * __usePpUploadCsvMutation__
 *
 * To run a mutation, you first call `usePpUploadCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePpUploadCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ppUploadCsvMutation, { data, loading, error }] = usePpUploadCsvMutation({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      reportType: // value for 'reportType'
 *   },
 * });
 */
export function usePpUploadCsvMutation(baseOptions?: Apollo.MutationHookOptions<PpUploadCsvMutation, PpUploadCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PpUploadCsvMutation, PpUploadCsvMutationVariables>(PpUploadCsvDocument, options);
      }
export type PpUploadCsvMutationHookResult = ReturnType<typeof usePpUploadCsvMutation>;
export type PpUploadCsvMutationResult = Apollo.MutationResult<PpUploadCsvMutation>;
export type PpUploadCsvMutationOptions = Apollo.BaseMutationOptions<PpUploadCsvMutation, PpUploadCsvMutationVariables>;
export const PpAwaitForUploadedFileIngestionDocument = gql`
    mutation pp_awaitForUploadedFileIngestion($partnerId: String!, $reportType: DataReportType!, $silentOnSuccess: Boolean!) {
  awaitForUploadedFileIngestion(
    partnerId: $partnerId
    reportType: $reportType
    silentOnSuccess: $silentOnSuccess
  ) {
    dataTypeName
    tableName
    isSuccess
  }
}
    `;
export type PpAwaitForUploadedFileIngestionMutationFn = Apollo.MutationFunction<PpAwaitForUploadedFileIngestionMutation, PpAwaitForUploadedFileIngestionMutationVariables>;

/**
 * __usePpAwaitForUploadedFileIngestionMutation__
 *
 * To run a mutation, you first call `usePpAwaitForUploadedFileIngestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePpAwaitForUploadedFileIngestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ppAwaitForUploadedFileIngestionMutation, { data, loading, error }] = usePpAwaitForUploadedFileIngestionMutation({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      reportType: // value for 'reportType'
 *      silentOnSuccess: // value for 'silentOnSuccess'
 *   },
 * });
 */
export function usePpAwaitForUploadedFileIngestionMutation(baseOptions?: Apollo.MutationHookOptions<PpAwaitForUploadedFileIngestionMutation, PpAwaitForUploadedFileIngestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PpAwaitForUploadedFileIngestionMutation, PpAwaitForUploadedFileIngestionMutationVariables>(PpAwaitForUploadedFileIngestionDocument, options);
      }
export type PpAwaitForUploadedFileIngestionMutationHookResult = ReturnType<typeof usePpAwaitForUploadedFileIngestionMutation>;
export type PpAwaitForUploadedFileIngestionMutationResult = Apollo.MutationResult<PpAwaitForUploadedFileIngestionMutation>;
export type PpAwaitForUploadedFileIngestionMutationOptions = Apollo.BaseMutationOptions<PpAwaitForUploadedFileIngestionMutation, PpAwaitForUploadedFileIngestionMutationVariables>;
export const PpGetHelpUrlForTableDocument = gql`
    mutation pp_getHelpUrlForTable($schemaType: PublicSchemaReportSchemaType!, $tableName: String!) {
  getHelpUrlPublicSchema(schemaType: $schemaType, tableName: $tableName) {
    url
  }
}
    `;
export type PpGetHelpUrlForTableMutationFn = Apollo.MutationFunction<PpGetHelpUrlForTableMutation, PpGetHelpUrlForTableMutationVariables>;

/**
 * __usePpGetHelpUrlForTableMutation__
 *
 * To run a mutation, you first call `usePpGetHelpUrlForTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePpGetHelpUrlForTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ppGetHelpUrlForTableMutation, { data, loading, error }] = usePpGetHelpUrlForTableMutation({
 *   variables: {
 *      schemaType: // value for 'schemaType'
 *      tableName: // value for 'tableName'
 *   },
 * });
 */
export function usePpGetHelpUrlForTableMutation(baseOptions?: Apollo.MutationHookOptions<PpGetHelpUrlForTableMutation, PpGetHelpUrlForTableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PpGetHelpUrlForTableMutation, PpGetHelpUrlForTableMutationVariables>(PpGetHelpUrlForTableDocument, options);
      }
export type PpGetHelpUrlForTableMutationHookResult = ReturnType<typeof usePpGetHelpUrlForTableMutation>;
export type PpGetHelpUrlForTableMutationResult = Apollo.MutationResult<PpGetHelpUrlForTableMutation>;
export type PpGetHelpUrlForTableMutationOptions = Apollo.BaseMutationOptions<PpGetHelpUrlForTableMutation, PpGetHelpUrlForTableMutationVariables>;
export const PpGetPbiTokenDocument = gql`
    mutation pp_getPBIToken($reportId: String!, $groupId: String!) {
  generatePowerBIReportContext(reportId: $reportId, groupId: $groupId) {
    embedUrl
    accessToken
  }
}
    `;
export type PpGetPbiTokenMutationFn = Apollo.MutationFunction<PpGetPbiTokenMutation, PpGetPbiTokenMutationVariables>;

/**
 * __usePpGetPbiTokenMutation__
 *
 * To run a mutation, you first call `usePpGetPbiTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePpGetPbiTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ppGetPbiTokenMutation, { data, loading, error }] = usePpGetPbiTokenMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function usePpGetPbiTokenMutation(baseOptions?: Apollo.MutationHookOptions<PpGetPbiTokenMutation, PpGetPbiTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PpGetPbiTokenMutation, PpGetPbiTokenMutationVariables>(PpGetPbiTokenDocument, options);
      }
export type PpGetPbiTokenMutationHookResult = ReturnType<typeof usePpGetPbiTokenMutation>;
export type PpGetPbiTokenMutationResult = Apollo.MutationResult<PpGetPbiTokenMutation>;
export type PpGetPbiTokenMutationOptions = Apollo.BaseMutationOptions<PpGetPbiTokenMutation, PpGetPbiTokenMutationVariables>;
export const PbiExportDocument = gql`
    mutation PbiExport($reportId: String!, $groupId: String!, $format: PowerBIReportExportFormat!, $bookmarkState: String, $pages: [PowerBIReportExportPageInput!]) {
  exportPowerBIReport(
    reportId: $reportId
    groupId: $groupId
    format: $format
    bookmarkState: $bookmarkState
    pages: $pages
  ) {
    exportId
  }
}
    `;
export type PbiExportMutationFn = Apollo.MutationFunction<PbiExportMutation, PbiExportMutationVariables>;

/**
 * __usePbiExportMutation__
 *
 * To run a mutation, you first call `usePbiExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePbiExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pbiExportMutation, { data, loading, error }] = usePbiExportMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      groupId: // value for 'groupId'
 *      format: // value for 'format'
 *      bookmarkState: // value for 'bookmarkState'
 *      pages: // value for 'pages'
 *   },
 * });
 */
export function usePbiExportMutation(baseOptions?: Apollo.MutationHookOptions<PbiExportMutation, PbiExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PbiExportMutation, PbiExportMutationVariables>(PbiExportDocument, options);
      }
export type PbiExportMutationHookResult = ReturnType<typeof usePbiExportMutation>;
export type PbiExportMutationResult = Apollo.MutationResult<PbiExportMutation>;
export type PbiExportMutationOptions = Apollo.BaseMutationOptions<PbiExportMutation, PbiExportMutationVariables>;
export const PbiExportRefreshStatusDocument = gql`
    mutation PbiExportRefreshStatus($reportId: String!, $groupId: String!, $format: PowerBIReportExportFormat!, $exportId: String!) {
  refreshPowerBIReportExportStatus(
    reportId: $reportId
    groupId: $groupId
    format: $format
    exportId: $exportId
  ) {
    status
    exportCompletionPercentage
    downloadUrl
    reportName
  }
}
    `;
export type PbiExportRefreshStatusMutationFn = Apollo.MutationFunction<PbiExportRefreshStatusMutation, PbiExportRefreshStatusMutationVariables>;

/**
 * __usePbiExportRefreshStatusMutation__
 *
 * To run a mutation, you first call `usePbiExportRefreshStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePbiExportRefreshStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pbiExportRefreshStatusMutation, { data, loading, error }] = usePbiExportRefreshStatusMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      groupId: // value for 'groupId'
 *      format: // value for 'format'
 *      exportId: // value for 'exportId'
 *   },
 * });
 */
export function usePbiExportRefreshStatusMutation(baseOptions?: Apollo.MutationHookOptions<PbiExportRefreshStatusMutation, PbiExportRefreshStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PbiExportRefreshStatusMutation, PbiExportRefreshStatusMutationVariables>(PbiExportRefreshStatusDocument, options);
      }
export type PbiExportRefreshStatusMutationHookResult = ReturnType<typeof usePbiExportRefreshStatusMutation>;
export type PbiExportRefreshStatusMutationResult = Apollo.MutationResult<PbiExportRefreshStatusMutation>;
export type PbiExportRefreshStatusMutationOptions = Apollo.BaseMutationOptions<PbiExportRefreshStatusMutation, PbiExportRefreshStatusMutationVariables>;
export const GetMarketplacesDocument = gql`
    query GetMarketplaces {
  marketplaceUrls {
    ...Marketplace
  }
}
    ${MarketplaceFragmentDoc}`;

/**
 * __useGetMarketplacesQuery__
 *
 * To run a query within a React component, call `useGetMarketplacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketplacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketplacesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMarketplacesQuery(baseOptions?: Apollo.QueryHookOptions<GetMarketplacesQuery, GetMarketplacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarketplacesQuery, GetMarketplacesQueryVariables>(GetMarketplacesDocument, options);
      }
export function useGetMarketplacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarketplacesQuery, GetMarketplacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarketplacesQuery, GetMarketplacesQueryVariables>(GetMarketplacesDocument, options);
        }
export type GetMarketplacesQueryHookResult = ReturnType<typeof useGetMarketplacesQuery>;
export type GetMarketplacesLazyQueryHookResult = ReturnType<typeof useGetMarketplacesLazyQuery>;
export type GetMarketplacesQueryResult = Apollo.QueryResult<GetMarketplacesQuery, GetMarketplacesQueryVariables>;